"use client"

import { useState, useEffect, useCallback } from "react"
import { getDatabase, ref as dbRef, onValue, get, set, remove, update } from "firebase/database"
import { db, ref } from "../Firebase/firestore";
import { push } from "firebase/database";
import { getStorage, ref as storageRef, uploadBytesResumable, getDownloadURL, listAll } from "firebase/storage"
import {
  FaUser,
  FaFileUpload,
  FaFileDownload,
  FaEye,
  FaCheckCircle,
  FaTimesCircle,
  FaSearch,
  FaFileAlt,
  FaFileInvoice,
  FaIdCard,
  FaFileContract,
  FaBuilding,
  FaFileSignature,
  FaMoneyCheckAlt,
  FaDatabase,
  FaSave,
  FaEdit,
  FaPlus,
  FaChevronDown,
  FaChevronUp,
  FaSpinner,
  FaMapMarkerAlt,
  FaTrash,
  FaBell,
} from "react-icons/fa"
import "./clientRecords.css"

const indianStates = [
  "Andhra Pradesh",
  "Arunachal Pradesh",
  "Assam",
  "Bihar",
  "Chhattisgarh",
  "Goa",
  "Gujarat",
  "Haryana",
  "Himachal Pradesh",
  "Jharkhand",
  "Karnataka",
  "Kerala",
  "Madhya Pradesh",
  "Maharashtra",
  "Manipur",
  "Meghalaya",
  "Mizoram",
  "Nagaland",
  "Odisha",
  "Punjab",
  "Rajasthan",
  "Sikkim",
  "Tamil Nadu",
  "Telangana",
  "Tripura",
  "Uttar Pradesh",
  "Uttarakhand",
  "West Bengal",
  "Andaman and Nicobar Islands",
  "Chandigarh",
  "Dadra and Nagar Haveli and Daman and Diu",
  "Delhi",
  "Jammu and Kashmir",
  "Ladakh",
  "Lakshadweep",
  "Puducherry",
]

const UserDocumentManagement = () => {
  const [users, setUsers] = useState([])
  const [selectedUser, setSelectedUser] = useState(null)
  const [searchTerm, setSearchTerm] = useState("")
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState("")
  const [mtcFiles, setMtcFiles] = useState([])
  const [statementFiles, setStatementFiles] = useState([])
  const [userDocuments, setUserDocuments] = useState({})
  const [uploadProgress, setUploadProgress] = useState({})
  const [activeTab, setActiveTab] = useState("profile")
  const [userCodes, setUserCodes] = useState([])
  const [expandedCodes, setExpandedCodes] = useState({})
  const [editingCode, setEditingCode] = useState(null)
  const [editedCodeData, setEditedCodeData] = useState(null)
  const [addingSiteToCode, setAddingSiteToCode] = useState(null)
  const [newSiteForm, setNewSiteForm] = useState({
    address: "",
    state: "",
    pincode: "",
  })
  // Order history states
  const [orderHistory, setOrderHistory] = useState([])
  const [pendingOrdersCount, setPendingOrdersCount] = useState(0)
  const [notified, setNotified] = useState(false);
  const [formErrors, setFormErrors] = useState({});

  // New states for PO details
  const [poList, setPoList] = useState([])
  const [expandedPOs, setExpandedPOs] = useState({})
  const [editingPO, setEditingPO] = useState(null)
  const [editedPOData, setEditedPOData] = useState(null)
  const [touched, setTouched] = useState({});
  const [submitted, setSubmitted] = useState(false);

  useEffect(() => {
    if (!selectedUser) return
    const poRef = dbRef(database, `ActivePO/${selectedUser.uid}`)
    onValue(poRef, (snapshot) => {
      if (snapshot.exists()) {
        const data = snapshot.val()
        const list = Object.entries(data).map(([id, po]) => ({
          id,       // Firebase key
          ...po,    // PO details
        }))
        setPoList(list)
      } else {
        setPoList([])
      }
    })
  }, [selectedUser])

  const handleSelectPO = (poId) => {
    setNewPOForm((prev) => {
      const selectedPO = poList.find((po) => po.id === poId);

      if (selectedPO) {
        return {
          ...prev,        // keep whatever was in the form
          ...selectedPO,  // overwrite with PO details
          poNumber: poId,
          code: selectedPO.code || prev.code, // keep code if not in PO
        };
      }

      // if no PO found, just update poNumber
      return { ...prev, poNumber: poId };
    });
  };


  const initialNewPOForm = {
    poNumber: "",
    quantity: "",
    grade: "",
    materialType: "",
    basicPrice: "",
    gstPercentage: "",
    totalPrice: "",
    packaging: "",
    gstNo: "",
    panNo: "",
    paymentTerms: "",
    billingAddress: "",
    siteAddress: { address: "", state: "", pincode: "" },
    contactPerson: "",
    contactMobile: "",
    deliverySchedule: "",
    endUse: "",
    category: "",
    email: "",
    tpcCode: "",
    orderedQuantity: "",
    deliveredQuantity: "0",
    creationDate: "",
    status: "active",
    notifiedExpired: false,
    notifiedExceeded: false,
    notifiedPending: false,
    brand: "",
    code: "",
    companyName: "",
    existingBalance: "",
    paymentAmount: "",
    paymentFileUrl: "",
    paymentMethod: "",
    poFileUrl: "",
    quantityType: "",
    rate: "",
    usingExistingBalance: false,
    utrNumber: "",
  }

  const [newPOForm, setNewPOForm] = useState(initialNewPOForm)

  const [copiedAddresses, setCopiedAddresses] = useState([])
  const [showAddressDropdown, setShowAddressDropdown] = useState(false)
  const [showNewSiteAddressDropdown, setShowNewSiteAddressDropdown] = useState(false)
  const REQUIRED_DOCS = ["mtc", "statement"];
  const REQUIRED_CODE_DOCS = []; // example types


  const [newCodeForm, setNewCodeForm] = useState({
    codeID: "",
    brand: "",
    depoName: "",
    balance: "",
    cementSiteType: "",
    depoAccount: {
      AccountNumber: "",
      BeneficiaryName: "",
      IFSC: "",
      Branch: "",
    },
    sites: {
      1: {
        address: "",
        state: "",
        pincode: "",
      },
    },
  })

  const [validation, setValidation] = useState({
    codeID: { isValid: true, message: "" },
    brand: { isValid: true, message: "" },
    depoName: { isValid: true, message: "" },
    depoAccount: { isValid: true, message: "" },
    sites: { isValid: true, message: "" },
  })
  const gifUrl = "/Images/New notification.gif";

  const getIndianTimestamp = () => {
    const now = new Date();
    const istOffset = 5.5 * 60 * 60 * 1000; // IST is UTC+5:30
    const istTime = new Date(now.getTime() + istOffset);
    return istTime.toISOString().replace("T", " ").replace("Z", "");
  };

  // ✅ Function to send notification
  const sendNotification = async (userId, codeId, title, message) => {
    const db = getDatabase()
    const notificationRef = ref(db, `user_notifications/New Code/${userId}/${codeId}`)

    const newNotification = {
      title,
      message,
      gifUrl, // use global constant
      timestamp: getIndianTimestamp(), // formatted timestamp
      seen: false,
    }

    try {
      await set(notificationRef, newNotification)
      console.log("Notification sent successfully:", newNotification)
    } catch (error) {
      console.error("Error sending notification:", error)
    }
  }
  const markTouched = (key) =>
    setTouched((t) => ({ ...t, [key]: true }));

  const clearFieldError = (key) =>
    setFormErrors((errs) => {
      if (!errs[key]) return errs;
      const { [key]: _, ...rest } = errs;
      return rest;
    });


  const storage = getStorage()
  const database = getDatabase()

  const [depots, setDepots] = useState([]);

  // Load copied addresses from localStorage
  useEffect(() => {
    const loadCopiedAddresses = () => {
      const addresses = JSON.parse(localStorage.getItem("copiedSiteAddresses") || "[]")
      setCopiedAddresses(addresses)
    }

    loadCopiedAddresses()

    // Listen for new copied addresses
    const handleAddressCopied = (event) => {
      loadCopiedAddresses()
      // Show success message
      if (event.detail?.message) {
        alert(event.detail.message)
      }
    }

    window.addEventListener("siteAddressCopied", handleAddressCopied)

    return () => {
      window.removeEventListener("siteAddressCopied", handleAddressCopied)
    }
  }, [])

  useEffect(() => {
    const db = getDatabase();
    const depotsRef = ref(db, 'Cement-depos');
    onValue(depotsRef, (snapshot) => {
      const data = snapshot.val();
      const depotsList = [];
      for (let id in data) {
        depotsList.push({ id, ...data[id] });
      }
      setDepots(depotsList);
    });
  }, []);

  // Function to apply copied address to new code form
  const applyCopiedAddress = (addressData) => {
    setNewCodeForm((prev) => ({
      ...prev,
      sites: {
        ...prev.sites,
        1: {
          address: addressData.address,
          state: addressData.state,
          pincode: addressData.pincode,
        },
      },
    }))
    setShowAddressDropdown(false)

    // Clear validation errors for sites
    setValidation((prev) => ({
      ...prev,
      sites: { isValid: true, message: "" },
    }))
  }

  // Function to apply copied address to new site form
  const applyCopiedAddressForNewSite = (addressData) => {
    setNewSiteForm({
      address: addressData.address,
      state: addressData.state,
      pincode: addressData.pincode,
    })
    setShowNewSiteAddressDropdown(false)
  }

  // Function to clear a specific copied address
  const clearCopiedAddress = (index) => {
    const updatedAddresses = copiedAddresses.filter((_, i) => i !== index)
    localStorage.setItem("copiedSiteAddresses", JSON.stringify(updatedAddresses))
    setCopiedAddresses(updatedAddresses)
  }

  // Function to clear all copied addresses
  const clearAllCopiedAddresses = () => {
    if (window.confirm("Are you sure you want to clear all copied addresses?")) {
      localStorage.removeItem("copiedSiteAddresses")
      setCopiedAddresses([])
    }
  }

  function getMissingDocuments(userDocuments, mtcFiles, statementFiles) {
    const globalMissing = [];

    if (mtcFiles.length === 0) globalMissing.push("Material Test Certificate (MTC)");
    if (statementFiles.length === 0) globalMissing.push("User Statement");

    const codeWiseMissing = {};
    Object.entries(userDocuments || {}).forEach(([codeId, docs]) => {
      const missing = [];
      REQUIRED_CODE_DOCS.forEach((docType) => {
        if (!docs[docType]) {
          missing.push(formatDocumentName(docType));
        }
      });
      if (missing.length > 0) {
        codeWiseMissing[codeId] = missing;
      }
    });

    return { globalMissing, codeWiseMissing };
  }


  useEffect(() => {
    const today = new Date();
    const lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0).getDate();

    if (!selectedUser) {
      console.warn("⏭ Skipping notification: No user selected");
      return;
    }

    // force trigger for testing
    if (today.getDate() === lastDay) {
      const { globalMissing, codeWiseMissing } = getMissingDocuments(userDocuments, mtcFiles, statementFiles);

      // 🔹 Send global docs notification (MTC, Statement)
      if (globalMissing.length > 0) {
        sendMissingDocNotification(selectedUser, globalMissing, "global");
      }

      // 🔹 Send code-wise missing docs
      Object.entries(codeWiseMissing).forEach(([codeId, docs]) => {
        sendMissingDocNotification(selectedUser, docs, codeId);
      });
    }
  }, [userDocuments, mtcFiles, statementFiles, selectedUser]);



  function sendMissingDocNotification(user, missingDocs, codeId = null) {
    const userId = user.id || user.uid || user.userId || user.email;
    if (!userId) {
      console.error("❌ No valid user ID found for notification", user);
      return;
    }

    const timestamp = new Date();
    const notificationId = `notification_${Date.now()}_${Math.floor(Math.random() * 1000)}`;

    const formattedTimestamp = `${timestamp.getFullYear()}-${String(
      timestamp.getMonth() + 1
    ).padStart(2, "0")}-${String(timestamp.getDate()).padStart(2, "0")} ${String(
      timestamp.getHours()
    ).padStart(2, "0")}:${String(timestamp.getMinutes()).padStart(2, "0")}:${String(
      timestamp.getSeconds()
    ).padStart(2, "0")}.${timestamp.getMilliseconds()}`;

    // 🟢 Build message dynamically
    let message = "";
    if (missingDocs.length === 0) {
      message = codeId && codeId !== "global"
        ? `All required documents are already uploaded for Code ID: ${codeId}. ✅`
        : `All global documents are already uploaded. ✅`;
    } else {
      message = codeId && codeId !== "global"
        ? `Please upload the required documents for Code ID: ${codeId} before month-end closing:\n- ${missingDocs.join("\n- ")}`
        : `Please upload the following documents before month-end closing:\n- ${missingDocs.join("\n- ")}`;
    }

    const notification = {
      title: "Missing Documents Reminder",
      message,
      gifUrl: "/Images/New notification.gif",
      orderId: null,
      timestamp: formattedTimestamp,
      seen: false,
      clicked: false,
    };

    set(ref(db, `user_notifications/Missing_Docs/${userId}/${notificationId}`), notification)
      .then(() => console.log("✅ Notification saved:", userId, codeId, missingDocs))
      .catch((err) => console.error("🔥 Error saving notification:", err));
  }


  function sendPONotification(user, po, type) {
    const userId = user.id || user.uid || user.userId || user.email;
    if (!userId) {
      console.error("❌ No valid user ID found for PO notification", user);
      return;
    }

    const timestamp = new Date();
    const notificationId = `po_notification_${Date.now()}_${Math.floor(Math.random() * 1000)}`;

    const formattedTimestamp = `${timestamp.getFullYear()}-${String(
      timestamp.getMonth() + 1
    ).padStart(2, "0")}-${String(timestamp.getDate()).padStart(2, "0")} ${String(
      timestamp.getHours()
    ).padStart(2, "0")}:${String(timestamp.getMinutes()).padStart(2, "0")}:${String(
      timestamp.getSeconds()
    ).padStart(2, "0")}.${timestamp.getMilliseconds()}`;

    let message = "";
    switch (type) {
      case "po_created":
        message = `A new PO ${po.poNumber} has been created for ${po.quantity} bags of ${po.brand} ${po.grade}.`;
        break;
      case "po_updated":
        message = `Your PO ${po.poNumber} has been updated. Please review the latest details.`;
        break;
      case "expired_30days":
        message = `Your PO ${po.poNumber} has expired after 30 days. Please create a new PO for pending bags if any.`;
        break;
      case "quantity_exceeded":
        message = `Quantity exceeded in PO ${po.poNumber} (ordered: ${po.orderedQuantity}, delivered: ${po.deliveredQuantity}). Please create a new PO.`;
        break;
      case "pending_overdue":
        message = `PO ${po.poNumber} has pending bags and is over 30 days old. Please create a new PO for the remaining ${po.orderedQuantity - po.deliveredQuantity} bags.`;
        break;
      case "order_completed":
        message = `Your dispatch of ${po.quantity} bags for ${po.brand} ${po.grade} at ${po.siteAddress.address}, ${po.siteAddress.state}${po.siteAddress.pincode ? `, ${po.siteAddress.pincode}` : ""} has been marked as the final dispatch. Your order is now complete. Thank you for ordering with us.`;
        break;
      default:
        message = `Issue with PO ${po.poNumber}.`;
    }

    const notification = {
      title: type === "order_completed" ? "Order Completed" : "Purchase Order Alert",
      message,
      gifUrl: "/Images/New notification.gif",
      orderId: po.id,
      timestamp: formattedTimestamp,
      seen: false,
      clicked: false,
    };

    // 🔹 Map types to Firebase folders
    let folder = "PO_Alerts"; // default
    if (type === "order_completed") folder = "Order Dispatch";
    if (type === "po_created") folder = "PO_Alerts";       // ✅ same as other PO alerts
    if (type === "po_updated") folder = "PO_Alerts";       // ✅ same folder
    if (type === "expired_30days" || type === "quantity_exceeded" || type === "pending_overdue")
      folder = "PO_Alerts";

    // ✅ Save notification to Firebase
    set(
      ref(db, `user_notifications/${folder}/${userId}/${notificationId}`),
      notification
    )
      .then(() => console.log(`✅ PO Notification saved in ${folder}:`, userId, po.poNumber, type))
      .catch((err) => console.error("🔥 Error saving PO notification:", err));
  }


  // const testUser = { uid: "BzQra8FUyRbwAv0JjLWzBoRVkGD2" }; // replace with your test user's ID
  // const testPO = {
  //   id: "PO12345",
  //   poNumber: "PO-001",
  //   orderedQuantity: 2000,
  //   deliveredQuantity: 2100,
  //   quantity: 2000,
  //   brand: "Ambuja",
  //   grade: "OPC43",
  //   siteAddress: { address: "Test Site", state: "HP", pincode: "177001" },
  // };

  // // Fire each case one by one:
  // sendPONotification(testUser, testPO, "expired_30days");
  // sendPONotification(testUser, testPO, "quantity_exceeded");
  // sendPONotification(testUser, testPO, "pending_overdue");

  useEffect(() => {
    const fetchUsers = async () => {
      setLoading(true)
      try {
        const usersRef = dbRef(database, "profileDashboard")
        onValue(usersRef, (snapshot) => {
          if (snapshot.exists()) {
            const usersData = snapshot.val()
            const usersArray = Object.keys(usersData).map((uid) => ({
              uid,
              ...usersData[uid],
            }))
            setUsers(usersArray)
          } else {
            setUsers([])
          }
          setLoading(false)
        })
      } catch (err) {
        setError(`Error fetching users: ${err.message}`)
        setLoading(false)
      }
    }

    fetchUsers()
  }, [database])

  // 🔹 Step 1: Fetch all codeIds from Realtime Database
  const fetchUserDocuments = useCallback(
    async (userId) => {
      try {
        const documentFields = [
          "gstCopy",
          "panCard",
          "workOrder",
          "purchaseOrder",
          "partnershipDeed",
          "cancelCheque",
        ];

        const codesRef = dbRef(database, `new-code/${userId}/codes`);
        const codesSnap = await get(codesRef);

        const documentsByCode = {};

        if (codesSnap.exists()) {
          const codesData = codesSnap.val();
          const codeEntries = Object.values(codesData); // get inner objects

          await Promise.all(
            codeEntries.map(async (codeObj) => {
              const codeId = codeObj.codeID; // <-- use codeID property
              if (!codeId) return;

              const docsForCode = {};

              await Promise.all(
                documentFields.map(async (field) => {
                  const docRef = storageRef(
                    storage,
                    `userDocuments/${userId}/${codeId}/${field}`
                  );
                  try {
                    const url = await getDownloadURL(docRef);
                    docsForCode[field] = url;
                  } catch (error) {
                    docsForCode[field] = null; // not uploaded
                  }
                })
              );

              documentsByCode[codeId] = docsForCode;
            })
          );
        }

        setUserDocuments(documentsByCode || {});
      } catch (err) {
        console.error("Error fetching user documents:", err);
        setError(`Error fetching user documents: ${err.message}`);
      }
    },
    [storage, database]
  );

  const fetchUserFiles = useCallback(
    async (userId) => {
      try {
        const mtcRef = storageRef(storage, `mtc/${userId}`)
        const mtcList = await listAll(mtcRef)
        const mtcUrls = await Promise.all(
          mtcList.items.map(async (file) => {
            const url = await getDownloadURL(file)
            return { name: file.name, url }
          }),
        )

        const statementRef = storageRef(storage, `user-statements/${userId}`)
        let statementUrls = []
        try {
          const statementList = await listAll(statementRef)
          statementUrls = await Promise.all(
            statementList.items.map(async (file) => {
              const url = await getDownloadURL(file)
              return { name: file.name, url }
            }),
          )
        } catch (err) {
          // No statements found, continue
        }

        setMtcFiles(mtcUrls.length > 0 ? mtcUrls.reverse() : [])
        setStatementFiles(statementUrls.length > 0 ? statementUrls.reverse() : [])
      } catch (err) {
        setError(`Error fetching files: ${err.message}`)
      }
    },
    [storage],
  )

  const fetchUserCodes = useCallback(
    async (userId) => {
      if (!userId) return

      try {
        setLoading(true)
        setUserCodes([])

        const userCodesRef = dbRef(database, `new-code/${userId}/codes`)
        const codesSnapshot = await get(userCodesRef)

        if (codesSnapshot.exists()) {
          const codesData = codesSnapshot.val()
          const codesArray = Object.entries(codesData).map(([codeKey, codeData]) => ({
            id: codeKey,
            ...codeData,
          }))
          setUserCodes(codesArray)
        }

        setLoading(false)
      } catch (err) {
        console.error("Error fetching user codes:", err)
        setError(`Error fetching user codes: ${err.message}`)
        setLoading(false)
      }
    },
    [database],
  )

  // New function to fetch PO list
  const fetchPOList = useCallback(
    (userId) => {
      if (!userId) return;

      const poRef = dbRef(database, `ActivePO/${userId}`);
      onValue(poRef, (snapshot) => {
        if (snapshot.exists()) {
          const posData = snapshot.val();
          const posArray = Object.entries(posData).map(([poKey, poData]) => ({
            id: poKey,
            poNumber: poData.poNumber || poData.PO, // Standardize
            ...poData,
          }));
          setPoList(posArray);
        } else {
          setPoList([]);
        }
      });
    },
    [database]
  );

  // New function to calculate delivered quantity (hypothetical, based on order history)
  const calculateDeliveredQuantity = (poId) => {
    // Assuming orders have poId field; sum quantities for matching poId and delivered status
    return orderHistory
      .filter(order => order.poId === poId && order.status === 'delivered')
      .reduce((sum, order) => sum + parseInt(order.quantity || 0), 0);
  };

  // New useEffect for PO expiration checks
  useEffect(() => {
    if (!selectedUser || poList.length === 0) return;

    poList.forEach(async (po) => {
      if (po.status !== 'active') return;

      const creationDate = new Date(po.timestamp); // Use timestamp as creation
      const today = new Date();
      const daysDiff = Math.floor((today - creationDate) / (1000 * 60 * 60 * 24));

      const delivered = po.deliveredQuantity || calculateDeliveredQuantity(po.id); // Use stored or calculate
      const ordered = parseInt(po.quantity || 0); // quantity is ordered

      if (daysDiff > 30 && !po.notifiedExpired) {
        sendPONotification(selectedUser, po, 'expired_30days');
        await update(dbRef(database, `ActivePO/${selectedUser.uid}/${po.id}`), {
          notifiedExpired: true,
          status: 'expired',
        });
      }

      if (delivered > ordered && !po.notifiedExceeded) {
        sendPONotification(selectedUser, po, 'quantity_exceeded');
        await update(dbRef(database, `ActivePO/${selectedUser.uid}/${po.id}`), {
          notifiedExceeded: true,
          status: 'expired',
        });
      }

      if (delivered < ordered && daysDiff > 30 && !po.notifiedPending) {
        sendPONotification(selectedUser, po, 'pending_overdue');
        await update(dbRef(database, `ActivePO/${selectedUser.uid}/${po.id}`), {
          notifiedPending: true,
          status: 'expired',
        });
      }
    });
  }, [poList, selectedUser, orderHistory, database]);

  // New function to fetch order history
  const fetchOrderHistory = useCallback(
    async (userId) => {
      if (!userId) return

      try {
        setLoading(true)
        setOrderHistory([])
        setPendingOrdersCount(0)

        const ordersRef = dbRef(database, `orders/${userId}`)
        const ordersSnapshot = await get(ordersRef)

        if (ordersSnapshot.exists()) {
          const ordersData = ordersSnapshot.val()
          const ordersArray = Object.entries(ordersData).map(([orderId, orderData]) => ({
            id: orderId,
            ...orderData,
          }))
          setOrderHistory(ordersArray)

          // Count pending orders
          const pendingCount = ordersArray.filter(order => order.status?.toLowerCase() === "pending").length
          setPendingOrdersCount(pendingCount)
        }

        setLoading(false)
      } catch (err) {
        console.error("Error fetching order history:", err)
        setError(`Error fetching order history: ${err.message}`)
        setLoading(false)
      }
    },
    [database],
  )


  const updatePO = async (userId, poId, updatedFields) => {
    try {
      await update(dbRef(database, `ActivePO/${userId}/${poId}`), updatedFields);
      console.log("✅ PO updated successfully");
    } catch (err) {
      console.error("❌ Error updating PO:", err);
    }
  };


  function checkPOStatus(userId, poId, poData) {
    const now = Date.now();
    const thirtyDays = 30 * 24 * 60 * 60 * 1000;

    // Case 1: 30 days expired
    if (now - poData.createdAt > thirtyDays) {
      if (poData.deliveredQuantity >= poData.quantity) {
        sendPONotification(userId, poId, `⚠️ PO ${poData.poNumber} expired after 30 days.`, "po_expired");
      } else {
        sendPONotification(userId, poId, `⚠️ PO ${poData.poNumber} expired with pending quantity (${poData.quantity - poData.deliveredQuantity} left).`, "po_pending_expired");
      }
    }

    // Case 2: Quantity exceeded
    if (poData.deliveredQuantity > poData.quantity) {
      sendPONotification(userId, poId, `⚠️ PO ${poData.poNumber} exceeded quantity. Ordered ${poData.quantity}, delivered ${poData.deliveredQuantity}.`, "po_quantity_exceeded");
    }
  }

  useEffect(() => {
    if (selectedUser) {
      setUserCodes([])
      setExpandedCodes({})
      setUserDocuments({})
      setMtcFiles([])
      setStatementFiles([])
      setEditingCode(null)
      setEditedCodeData(null)
      setOrderHistory([])
      setPendingOrdersCount(0)

      setPoList([])
      setExpandedPOs({})
      setEditingPO(null)
      setEditedPOData(null)

      // Prefill newPOForm with user details
      setNewPOForm({
        ...initialNewPOForm,
        gstNo: selectedUser.gstin || "",
        panNo: selectedUser.pan || "",
        billingAddress: selectedUser.company_name ? `${selectedUser.company_name}, ${selectedUser.address || ""}` : "",
        siteAddress: { address: selectedUser.address || "", state: "", pincode: "" },
        contactPerson: selectedUser.username || "",
        contactMobile: selectedUser.phone || "",
        email: selectedUser.email || "",
        companyName: selectedUser.company_name || "",
        cementSiteType: selectedUser.cementSiteType || "",
      })

      fetchUserDocuments(selectedUser.uid)
      fetchUserFiles(selectedUser.uid)
      fetchUserCodes(selectedUser.uid)
      fetchOrderHistory(selectedUser.uid)
      fetchPOList(selectedUser.uid)
    }
  }, [selectedUser, fetchUserDocuments, fetchUserFiles, fetchUserCodes, fetchOrderHistory, fetchPOList])

  const handleFileUpload = (e, fileType) => {
    const file = e.target.files[0]
    if (!file || !selectedUser) return

    if (file.size > 5 * 1024 * 1024) {
      setError("File size must not exceed 5MB!")
      return
    }

    const validTypes = ["application/pdf", "image/jpeg", "image/png"]
    if (!validTypes.includes(file.type)) {
      setError("Only PDF, JPEG, and PNG files are allowed.")
      return
    }

    const timestamp = new Date().getTime()
    const fileName = `${fileType}_${timestamp}_${file.name}`
    const path =
      fileType === "mtc" ? `mtc/${selectedUser.uid}/${fileName}` : `user-statements/${selectedUser.uid}/${fileName}`

    const fileRef = storageRef(storage, path)
    const uploadTask = uploadBytesResumable(fileRef, file)

    setUploadProgress((prev) => ({
      ...prev,
      [fileType]: 0,
    }))

    uploadTask.on(
      "state_changed",
      (snapshot) => {
        const progress = Math.round((snapshot.bytesTransferred / snapshot.totalBytes) * 100)
        setUploadProgress((prev) => ({
          ...prev,
          [fileType]: progress,
        }))
      },
      (error) => {
        setError(`Upload failed: ${error.message}`)
        setUploadProgress((prev) => ({
          ...prev,
          [fileType]: null,
        }))
      },
      () => {
        setUploadProgress((prev) => ({
          ...prev,
          [fileType]: 100,
        }))
        fetchUserFiles(selectedUser.uid)
        setTimeout(() => {
          setUploadProgress((prev) => ({
            ...prev,
            [fileType]: null,
          }))
        }, 3000)
      },
    )
  }

  const handleDownload = (fileUrl, fileName) => {
    if (!fileUrl) {
      setError("File URL not found. Please try again.")
      return
    }

    const a = document.createElement("a")
    a.href = fileUrl
    a.download = fileName || "download"
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
  }

  const handleUserSelect = (user) => {
    setUserCodes([])
    setExpandedCodes({})
    setSelectedUser(user)
    setActiveTab("profile")
    setError("")
    setOrderHistory([])
    setPendingOrdersCount(0)
    setPoList([])
    setExpandedPOs({})

    setNewCodeForm({
      codeID: "",
      brand: "",
      balance: "",
      depoAccount: {
        AccountNumber: "",
        BeneficiaryName: "",
        IFSC: "",
        Branch: "",
      },
      sites: {
        1: {
          address: "",
          state: "",
          pincode: "",
        },
      },
    })
    setEditingCode(null)
    setEditedCodeData(null)
    setAddingSiteToCode(null)
    setEditingPO(null)
    setEditedPOData(null)
  }

  const toggleCodeExpansion = (codeId) => {
    setExpandedCodes((prev) => ({
      ...prev,
      [codeId]: !prev[codeId],
    }))
  }

  // New toggle for PO expansion
  const togglePOExpansion = (poId) => {
    setExpandedPOs((prev) => ({
      ...prev,
      [poId]: !prev[poId],
    }));
  };

  const startEditingCode = (code) => {
    setEditingCode(code.id)
    setEditedCodeData({ ...code })
  }

  const cancelEditingCode = () => {
    setEditingCode(null)
    setEditedCodeData(null)
  }

  const handleEditedCodeChange = (field, value) => {
    if (!editedCodeData) return

    if (field.includes(".")) {
      const [parent, child] = field.split(".")
      setEditedCodeData((prev) => ({
        ...prev,
        [parent]: {
          ...prev[parent],
          [child]: value,
        },
      }))
    } else {
      setEditedCodeData((prev) => ({
        ...prev,
        [field]: value,
      }))
    }
  }

  const saveEditedCode = async () => {
    if (!editedCodeData || !selectedUser) return

    try {
      setLoading(true)
      const codeRef = dbRef(database, `new-code/${selectedUser.uid}/codes/${editingCode}`)
      await set(codeRef, editedCodeData)

      setEditingCode(null)
      setEditedCodeData(null)
      fetchUserCodes(selectedUser.uid)
      alert("Code updated successfully!")
    } catch (err) {
      console.error("Error updating code:", err)
      setError(`Error updating code: ${err.message}`)
    } finally {
      setLoading(false)
    }
  }

  const toggleAddingSite = (codeId) => {
    if (addingSiteToCode === codeId) {
      setAddingSiteToCode(null)
      setNewSiteForm({
        address: "",
        state: "",
        pincode: "",
      })
    } else {
      setAddingSiteToCode(codeId)
      setNewSiteForm({
        address: "",
        state: "",
        pincode: "",
      })
    }
  }

  const handleNewSiteChange = (field, value) => {
    setNewSiteForm((prev) => ({
      ...prev,
      [field]: value,
    }))
  }

  const addNewSiteToCode = async (codeId) => {
    if (!newSiteForm.address || !newSiteForm.state) {
      setError("Address and state are required")
      return
    }

    if (newSiteForm.pincode && !/^\d{6}$/.test(newSiteForm.pincode)) {
      setError("Pincode must be a 6-digit number")
      return
    }

    try {
      setLoading(true)

      const codeRef = dbRef(database, `new-code/${selectedUser.uid}/codes/${codeId}`)
      const codeSnapshot = await get(codeRef)

      if (codeSnapshot.exists()) {
        const codeData = codeSnapshot.val()
        const sites = codeData.sites || {}
        const siteNumbers = Object.keys(sites).map(Number)
        const nextSiteNumber = siteNumbers.length > 0 ? Math.max(...siteNumbers) + 1 : 1

        const updatedSites = {
          ...sites,
          [nextSiteNumber]: newSiteForm,
        }

        await set(dbRef(database, `new-code/${selectedUser.uid}/codes/${codeId}/sites`), updatedSites)

        setNewSiteForm({
          address: "",
          state: "",
          pincode: "",
        })
        setAddingSiteToCode(null)
        fetchUserCodes(selectedUser.uid)
        alert("New site added successfully!")
      } else {
        setError("Code not found")
      }
    } catch (err) {
      console.error("Error adding new site:", err)
      setError(`Error adding new site: ${err.message}`)
    } finally {
      setLoading(false)
    }
  }

  const handleNewCodeChange = (field, value) => {
    if (field.includes(".")) {
      const [parent, child] = field.split(".")
      setNewCodeForm((prev) => ({
        ...prev,
        [parent]: {
          ...prev[parent],
          [child]: value,
        },
      }))
    } else {
      setNewCodeForm((prev) => ({
        ...prev,
        [field]: value,
      }))
    }

    validateNewCodeField(field, value)
  }

  const handleNewCodeSiteChange = (field, value) => {
    setNewCodeForm((prev) => ({
      ...prev,
      sites: {
        ...prev.sites,
        1: {
          ...prev.sites[1],
          [field]: value,
        },
      },
    }))

    validateNewCodeField(`sites.${field}`, value)
  }

  const validateNewCodeField = (field, value) => {
    let validationResult = { isValid: true, message: "" }

    if (field === "codeID") {
      if (!value) {
        validationResult = { isValid: false, message: "Code ID is required" }
      } else if (value.length > 20) {
        validationResult = { isValid: false, message: "Code ID must not exceed 20 characters" }
      } else if (!/^[A-Z0-9]+$/.test(value)) {
        validationResult = { isValid: false, message: "Code ID must contain only uppercase letters and digits" }
      }
    } else if (field === "brand") {
      if (!value) {
        validationResult = { isValid: false, message: "Brand selection is required" }
      }
    } else if (field.startsWith("depoAccount.")) {
      const depoField = field.split(".")[1]
      if (depoField === "AccountNumber") {
        if (!value) {
          validationResult = { isValid: false, message: "Account number is required" }
        } else if (value.length > 25) {
          validationResult = { isValid: false, message: "Account number must not exceed 25 characters" }
        } else if (!/^[A-Z0-9]+$/.test(value)) {
          validationResult = {
            isValid: false,
            message: "Account number must contain only uppercase letters and digits",
          }
        }
      } else if (depoField === "BeneficiaryName") {
        if (!value) {
          validationResult = { isValid: false, message: "Beneficiary name is required" }
        } else if (value.length > 50) {
          validationResult = { isValid: false, message: "Beneficiary name must not exceed 50 characters" }
        } else if (!/^[A-Za-z\s]+$/.test(value)) {
          validationResult = {
            isValid: false,
            message: "Beneficiary name must contain only letters and spaces (no digits allowed)",
          }
        }
      } else if (depoField === "IFSC") {
        if (!value) {
          validationResult = { isValid: false, message: "IFSC code is required" }
        } else if (!/^[A-Z]{4}0[A-Z0-9]{6}$/.test(value)) {
          validationResult = { isValid: false, message: "IFSC code must be in format: AAAA0XXXXXX (e.g., SBIN0123456)" }
        }
      } else if (depoField === "Branch") {
        if (!value) {
          validationResult = { isValid: false, message: "Bank name & branch is required" }
        } else if (!/^[A-Za-z0-9\s\-,.&()/]+$/.test(value)) {
          validationResult = {
            isValid: false,
            message: "Enter a valid bank name and branch (letters, numbers, and common punctuation allowed)",
          }
        }
      }

      setValidation((prev) => ({
        ...prev,
        depoAccount: validationResult,
      }))
      return
    } else if (field.startsWith("sites.")) {
      const siteField = field.split(".")[1]
      const address = siteField === "address" ? value : newCodeForm.sites[1].address
      const state = siteField === "state" ? value : newCodeForm.sites[1].state
      const pincode = siteField === "pincode" ? value : newCodeForm.sites[1].pincode

      if (!address || !state) {
        validationResult = { isValid: false, message: "Address and state are required" }
      } else if (pincode && !/^\d{6}$/.test(pincode)) {
        validationResult = { isValid: false, message: "Pincode must be a 6-digit number" }
      }

      setValidation((prev) => ({
        ...prev,
        sites: validationResult,
      }))
      return
    }

    setValidation((prev) => ({
      ...prev,
      [field.split(".")[0]]: validationResult,
    }))
  }

  const validateNewCodeForm = () => {
    const { codeID, brand, depoName, depoAccount, sites } = newCodeForm;
    let isValid = true;

    // Validate codeID
    if (!codeID.trim()) {
      validateNewCodeField("codeID", codeID, "Code ID is required");
      isValid = false;
    } else if (codeID.length > 20) {
      validateNewCodeField("codeID", codeID, "Code ID must not exceed 20 characters");
      isValid = false;
    } else if (!/^[A-Z0-9]+$/.test(codeID)) {
      validateNewCodeField("codeID", codeID, "Code ID must contain only uppercase letters and digits");
      isValid = false;
    }

    // Validate brand
    if (!brand.trim()) {
      validateNewCodeField("brand", brand, "Brand is required");
      isValid = false;
    }

    // Validate depoName only if brand is selected and depots are available
    if (brand && depots.filter(depot => depot.brandName === brand).length > 0 && !depoName.trim()) {
      validateNewCodeField("depoName", depoName, "Depot Name is required");
      isValid = false;
    }

    // Validate depoAccount.AccountNumber
    if (!depoAccount.AccountNumber.trim()) {
      validateNewCodeField("depoAccount.AccountNumber", depoAccount.AccountNumber, "Account Number is required");
      isValid = false;
    } else if (depoAccount.AccountNumber.length > 25) {
      validateNewCodeField("depoAccount.AccountNumber", depoAccount.AccountNumber, "Account Number must not exceed 25 characters");
      isValid = false;
    } else if (!/^[A-Z0-9]+$/.test(depoAccount.AccountNumber)) {
      validateNewCodeField("depoAccount.AccountNumber", depoAccount.AccountNumber, "Account Number must contain only uppercase letters and digits");
      isValid = false;
    }

    // Validate depoAccount.BeneficiaryName
    if (!depoAccount.BeneficiaryName.trim()) {
      validateNewCodeField("depoAccount.BeneficiaryName", depoAccount.BeneficiaryName, "Beneficiary Name is required");
      isValid = false;
    } else if (depoAccount.BeneficiaryName.length > 50) {
      validateNewCodeField("depoAccount.BeneficiaryName", depoAccount.BeneficiaryName, "Beneficiary Name must not exceed 50 characters");
      isValid = false;
    } else if (!/^[A-Za-z\s]+$/.test(depoAccount.BeneficiaryName)) {
      validateNewCodeField("depoAccount.BeneficiaryName", depoAccount.BeneficiaryName, "Beneficiary Name must contain only letters and spaces");
      isValid = false;
    }

    // Validate depoAccount.IFSC
    if (!depoAccount.IFSC.trim()) {
      validateNewCodeField("depoAccount.IFSC", depoAccount.IFSC, "IFSC Code is required");
      isValid = false;
    } else if (!/^[A-Z]{4}0[A-Z0-9]{6}$/.test(depoAccount.IFSC)) {
      validateNewCodeField("depoAccount.IFSC", depoAccount.IFSC, "IFSC Code must be in the format AAAA0XXXXXX");
      isValid = false;
    }

    // Validate depoAccount.Branch
    if (!depoAccount.Branch.trim()) {
      validateNewCodeField("depoAccount.Branch", depoAccount.Branch, "Bank & Branch is required");
      isValid = false;
    }

    // Validate sites
    if (!sites[1].address.trim() || !sites[1].state.trim()) {
      if (!sites[1].address.trim()) {
        validateNewCodeField("sites.address", sites[1].address, "Site address is required");
      }
      if (!sites[1].state.trim()) {
        validateNewCodeField("sites.state", sites[1].state, "Site state is required");
      }
      isValid = false;
    }

    if (sites[1].pincode && !/^\d{6}$/.test(sites[1].pincode)) {
      validateNewCodeField("sites.pincode", sites[1].pincode, "Pincode must be a 6-digit number");
      isValid = false;
    }

    return isValid;
  };

  const sanitizeData = (obj) => {
    const result = {};
    for (const [key, value] of Object.entries(obj)) {
      if (value === undefined) {
        result[key] = null;
      } else if (typeof value === "object" && value !== null) {
        result[key] = sanitizeData(value);
      } else {
        result[key] = value;
      }
    }
    return result;
  };

  const handleSubmitNewCode = async () => {
    if (!selectedUser) {
      setError("Please select a user first");
      return;
    }

    if (!validateNewCodeForm()) {
      setError("Please fix all validation errors before submitting");
      return;
    }

    try {
      setLoading(true);

      // 🔑 Raw UTC timestamp (universal)
      const nowUTC = Date.now();

      // 🔑 Human readable IST string (formatted properly)
      const nowISTFormatted = new Date(nowUTC).toLocaleString("en-IN", {
        timeZone: "Asia/Kolkata",
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: true,
      });

      const codeData = {
        codeID: newCodeForm.codeID,
        balance: newCodeForm.balance || null, // Handle disabled balance field
        brand: newCodeForm.brand,
        cementSiteType: newCodeForm.cementSiteType,
        depoName: newCodeForm.depoName || null, // Allow null if no depots available
        depoAccount: newCodeForm.depoAccount,
        sites: newCodeForm.sites,
        createdAt: nowUTC,
        createdAtFormatted: nowISTFormatted,
      };

      // Sanitize data to prevent undefined values
      const sanitizedCodeData = sanitizeData(codeData);

      const codesRef = dbRef(database, `new-code/${selectedUser.uid}/codes`);
      const codesSnapshot = await get(codesRef);

      if (codesSnapshot.exists()) {
        const codes = codesSnapshot.val();
        const codeExists = Object.values(codes).some(
          (code) => code.codeID === newCodeForm.codeID
        );

        if (codeExists) {
          setError(
            `Code ID ${newCodeForm.codeID} already exists. Please use a different Code ID.`
          );
          setLoading(false);
          return;
        }
      }

      // 🔑 Unique reference
      const newCodeKey = `code${nowUTC}`;
      const newCodeRef = dbRef(
        database,
        `new-code/${selectedUser.uid}/codes/${newCodeKey}`
      );

      await set(newCodeRef, sanitizedCodeData);

      // ✅ Notification
      const siteAddress = newCodeForm.sites[1]?.address || "N/A";
      const notificationTitle = "New Code Added";
      const notificationMessage = `A new code has been added under ${newCodeForm.brand}\nCode ID: ${newCodeForm.codeID}\nSite Address: ${siteAddress}`;

      await sendNotification(
        selectedUser.uid,
        newCodeKey,
        notificationTitle,
        notificationMessage
      );

      // ✅ Reset form
      setNewCodeForm({
        codeID: "",
        brand: "",
        depoName: "",
        balance: "",
        depoAccount: {
          AccountNumber: "",
          BeneficiaryName: "",
          IFSC: "",
          Branch: "",
        },
        sites: {
          1: {
            address: "",
            state: "",
            pincode: "",
          },
        },
      });

      setValidation({
        codeID: { isValid: true, message: "" },
        brand: { isValid: true, message: "" },
        depoName: { isValid: true, message: "" },
        depoAccount: { isValid: true, message: "" },
        sites: { isValid: true, message: "" },
      });

      fetchUserCodes(selectedUser.uid);
      alert("New code added successfully!");
    } catch (err) {
      console.error("Error submitting new code:", err);
      setError(`Error submitting new code: ${err.message}`);
    } finally {
      setLoading(false);
    }
  };

  // New handlers for PO
  const startEditingPO = (po) => {
    setEditingPO(po.id);
    setEditedPOData({ ...po });
  };

  const cancelEditingPO = () => {
    setEditingPO(null);
    setEditedPOData(null);
  };

  const handleEditedPOChange = (field, value) => {
    if (!editedPOData) return;
    setEditedPOData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleEditedPOSiteChange = (subfield, value) => {
    setEditedPOData((prev) => ({
      ...prev,
      siteAddress: {
        ...prev.siteAddress,
        [subfield]: value,
      },
    }));
  };

  const saveEditedPO = async () => {
    if (!editedPOData || !selectedUser) return;

    try {
      await update(
        dbRef(database, `ActivePO/${selectedUser.uid}/${editingPO}`),
        {
          ...editedPOData,
          lastUpdated: Date.now(),
        }
      );

      console.log("✅ PO updated successfully");

      // 🔔 Send notification for update
      sendPONotification(selectedUser, {
        ...editedPOData,
        id: editingPO,
        poNumber: editedPOData.poNumber || editingPO
      }, "po_updated");

      setEditingPO(null);
      setEditedPOData(null);
      fetchPOList(selectedUser.uid);
    } catch (err) {
      console.error("❌ Error saving PO:", err);
    }
  };


  const validateEditedPO = () => {
    let errors = {};

    if (!editedPOData.basicPrice || editedPOData.basicPrice <= 0)
      errors.basicPrice = "Basic Price must be a positive number";
    if (!editedPOData.gstPercentage || editedPOData.gstPercentage < 0 || editedPOData.gstPercentage > 100)
      errors.gstPercentage = "GST % must be between 0 and 100";
    if (!editedPOData.totalPrice || editedPOData.totalPrice <= 0)
      errors.totalPrice = "Total Price is required";

    if (!/^[0-9A-Z]{15}$/.test(editedPOData.gstNo || ""))
      errors.gstNo = "Invalid GST number (15 characters required)";
    if (!/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(editedPOData.panNo || ""))
      errors.panNo = "Invalid PAN number";

    if (!editedPOData.paymentTerms) errors.paymentTerms = "Payment terms required";
    if (!editedPOData.billingAddress) errors.billingAddress = "Billing address required";

    if (!editedPOData.siteAddress?.address || editedPOData.siteAddress.address.length < 5)
      errors.address = "Site address must be at least 200 characters";
    if (!editedPOData.siteAddress?.state) errors.state = "State is required";
    if (!/^\d{6}$/.test(editedPOData.siteAddress?.pincode || ""))
      errors.pincode = "Pincode must be 6 digits";

    if (!editedPOData.contactPerson) errors.contactPerson = "Contact person required";
    if (!/^\d{10}$/.test(editedPOData.contactMobile || ""))
      errors.contactMobile = "Invalid mobile number (10 digits required)";

    if (!editedPOData.category) errors.category = "Category is required";
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(editedPOData.email || ""))
      errors.email = "Invalid email address";
    if (!editedPOData.brand) errors.brand = "Brand is required";
    if (!editedPOData.companyName) errors.companyName = "Company name is required";
    if (!editedPOData.quantityType) errors.quantityType = "Quantity type required";
    if (!editedPOData.rate || editedPOData.rate <= 0)
      errors.rate = "Rate must be a positive number";

    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleNewPOChange = (field, value) => {
    setNewPOForm((prev) => ({
      ...prev,
      [field]: value,
    }));
    // Add validation if needed
  };

  const handleNewPOSiteChange = (subfield, value) => {
    setNewPOForm((prev) => ({
      ...prev,
      siteAddress: {
        ...prev.siteAddress,
        [subfield]: value,
      },
    }));
  };

  const handleSubmitNewPO = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;
    if (!selectedUser) return;

    setLoading(true);
    try {
      const userId = selectedUser.uid;
      const poRef = dbRef(database, `ActivePO/${userId}`);

      const timestamp = Date.now();

      // ✅ If editing an existing PO, don't overwrite with new timestamp
      const isEdit = !!newPOForm.id;
      const poId = isEdit ? newPOForm.id : `po${timestamp}`;
      const autoPONumber = isEdit ? newPOForm.poNumber : `PO-${timestamp}`;

      if (isEdit) {
        // 🔹 Update existing PO
        await update(dbRef(database, `ActivePO/${userId}/${poId}`), {
          ...newPOForm,
          poNumber: autoPONumber,
          lastUpdated: timestamp,
        });

        // 🔔 Send update notification
        sendPONotification(
          selectedUser,
          { ...newPOForm, poNumber: autoPONumber, id: poId },
          "po_updated"
        );

        console.log("✅ PO updated:", poId);
      } else {
        // 🔹 Create new PO
        await set(dbRef(database, `ActivePO/${userId}/${poId}`), {
          ...newPOForm,
          poNumber: autoPONumber,
          status: "active",
          creationDate: new Date().toISOString(),
          deliveredQuantity: "0",
          notifiedPending: false,
          notifiedExceeded: false,
          notifiedExpired: false,
        });

        // 🔔 Send create notification
        sendPONotification(
          selectedUser,
          { ...newPOForm, poNumber: autoPONumber, id: poId },
          "po_created"
        );

        console.log("✅ New PO created:", poId);
      }

      // Reset form
      setNewPOForm({
        ...initialNewPOForm,
        poNumber: isEdit ? autoPONumber : "",
      });

      fetchPOList(userId);
      alert(isEdit ? "PO updated successfully!" : "New PO added successfully!");
    } catch (err) {
      console.error("❌ Error submitting PO:", err);
      setError(`Error submitting new PO: ${err.message}`);
    } finally {
      setLoading(false);
    }
  };


  const validateForm = () => {
    let errors = {};

    if (!newPOForm.code) errors.code = "Code is required";
    if (!newPOForm.grade) errors.grade = "Grade is required";
    if (!newPOForm.quantity || newPOForm.quantity <= 0)
      errors.quantity = "Quantity must be a positive number";
    if (!newPOForm.rate || newPOForm.rate <= 0)
      errors.rate = "Rate must be a positive number";

    if (!newPOForm.siteAddress.address || newPOForm.siteAddress.address.length < 5)
      errors.address = "Site address must be at least 200 characters";
    if (!newPOForm.siteAddress.state) errors.state = "State is required";
    if (!/^\d{6}$/.test(newPOForm.siteAddress.pincode))
      errors.pincode = "Pincode must be 6 digits";

    if (!newPOForm.basicPrice) errors.basicPrice = "Basic Price is required";
    if (!newPOForm.gstPercentage || newPOForm.gstPercentage < 0 || newPOForm.gstPercentage > 100)
      errors.gstPercentage = "GST % must be between 0 and 100";
    if (!newPOForm.totalPrice) errors.totalPrice = "Total price is required";

    if (!/^[0-9A-Z]{15}$/.test(newPOForm.gstNo))
      errors.gstNo = "Invalid GST number (15 characters required)";
    if (!/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(newPOForm.panNo))
      errors.panNo = "Invalid PAN number";

    if (!newPOForm.paymentTerms) errors.paymentTerms = "Payment terms required";
    if (!newPOForm.billingAddress) errors.billingAddress = "Billing address required";
    if (!newPOForm.contactPerson) errors.contactPerson = "Contact person required";
    if (!/^\d{10}$/.test(newPOForm.contactMobile))
      errors.contactMobile = "Invalid mobile number (10 digits required)";
    if (!newPOForm.category) errors.category = "Category is required";
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(newPOForm.email))
      errors.email = "Invalid email address";
    if (!newPOForm.brand) errors.brand = "Brand is required";
    if (!newPOForm.companyName) errors.companyName = "Company name is required";
    if (!newPOForm.quantityType) errors.quantityType = "Quantity type required";

    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };


  const deletePO = async (poId) => {
    if (!selectedUser || !poId) return;

    if (!window.confirm("Are you sure you want to delete this PO? This action cannot be undone.")) {
      return;
    }

    try {
      setLoading(true);
      const poRef = dbRef(database, `ActivePO/${selectedUser.uid}/${poId}`);
      await remove(poRef);
      fetchPOList(selectedUser.uid);
      alert("PO deleted successfully!");
    } catch (err) {
      console.error("Error deleting PO:", err);
      setError(`Error deleting PO: ${err.message}`);
    } finally {
      setLoading(false);
    }
  };



  const deleteCode = async (codeId) => {
    if (!selectedUser || !codeId) return

    if (!window.confirm("Are you sure you want to delete this code? This action cannot be undone.")) {
      return
    }

    try {
      setLoading(true)
      const codeRef = dbRef(database, `new-code/${selectedUser.uid}/codes/${codeId}`)
      await remove(codeRef)
      fetchUserCodes(selectedUser.uid)
      alert("Code deleted successfully!")
    } catch (err) {
      console.error("Error deleting code:", err)
      setError(`Error deleting code: ${err.message}`)
    } finally {
      setLoading(false)
    }
  }

  const filteredUsers = users.filter((user) => {
    const searchFields = [user.username, user.email, user.company_name, user.phone, user.gstin, user.pan]
    return searchFields.some((field) => field && field.toLowerCase().includes(searchTerm.toLowerCase()))
  })

  const getDocumentIcon = (docType) => {
    switch (docType) {
      case "gstCopy":
        return <FaFileInvoice />
      case "panCard":
        return <FaIdCard />
      case "workOrder":
        return <FaFileContract />
      case "purchaseOrder":
        return <FaBuilding />
      case "partnershipDeed":
        return <FaFileSignature />
      case "cancelCheque":
        return <FaMoneyCheckAlt />
      default:
        return <FaFileAlt />
    }
  }

  const formatDocumentName = (name) => {
    return name.replace(/([A-Z])/g, " $1").trim()
  }

  // Handler functions for address clicks
  const handleAddressClickForNewSite = (addressData) => {
    applyCopiedAddressForNewSite(addressData)
  }

  const handleAddressClick = (addressData) => {
    applyCopiedAddress(addressData)
  }

  return (
    <div className="user-document-management">
      <div className="management-container">
        <div className="users-sidebar">
          <div className="search-container">
            <div className="search-input-wrapper">
              <FaSearch className="user-search-icon" />
              <input
                type="text"
                placeholder="Search users..."
                value={searchTerm}
                maxLength={37}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="search-input"
              />
            </div>
          </div>

          <div className="users-list">
            {loading && users.length === 0 ? (
              <div className="loading-indicator">
                <FaSpinner className="spinner-icon" /> Loading users...
              </div>
            ) : filteredUsers.length > 0 ? (
              filteredUsers.map((user) => (
                <div
                  key={user.uid}
                  className={`user-item ${selectedUser?.uid === user.uid ? "selected" : ""}`}
                  onClick={() => handleUserSelect(user)}
                >
                  <div className="user-avatar">
                    <FaUser />
                  </div>
                  <div className="user-info">
                    <div className="user-name">{user.username || "Unnamed User"}</div>
                    <div className="user-email">{user.company_name}</div>
                  </div>
                </div>
              ))
            ) : (
              <div className="no-results">No users found</div>
            )}
          </div>
        </div>

        <div className="content-area">
          {selectedUser ? (
            <>
              <div className="tabs-navigation">
                <button
                  className={`tab-button ${activeTab === "profile" ? "active" : ""}`}
                  onClick={() => setActiveTab("profile")}
                >
                  <FaUser /> Profile
                </button>
                <button
                  className={`tab-button ${activeTab === "uploads" ? "active" : ""}`}
                  onClick={() => setActiveTab("uploads")}
                >
                  <FaFileUpload /> Upload Files
                </button>
                <button
                  className={`tab-button ${activeTab === "documents" ? "active" : ""}`}
                  onClick={() => setActiveTab("documents")}
                >
                  <FaFileDownload /> User Documents
                </button>
                <button
                  className={`tab-button ${activeTab === "codeDetails" ? "active" : ""}`}
                  onClick={() => setActiveTab("codeDetails")}
                >
                  <FaDatabase /> Code Details
                </button>
                <button
                  className={`tab-button ${activeTab === "poDetails" ? "active" : ""}`}
                  onClick={() => setActiveTab("poDetails")}
                >
                  <FaFileInvoice /> PO Details
                </button>
                <button
                  className={`tab-button ${activeTab === "orderHistory" ? "active" : ""}`}
                  onClick={() => setActiveTab("orderHistory")}
                >
                  <FaDatabase /> Order History
                  {pendingOrdersCount > 0 && (
                    <span className="pending-count">{pendingOrdersCount}</span>
                  )}
                </button>

              </div>

              <div className="tab-content">
                {activeTab === "profile" && (
                  <div className="profile-tab">
                    <h2>User Profile</h2>
                    <div className="profile-details">
                      <div className="profile-field">
                        <label>Username:</label>
                        <span>{selectedUser.username || "Not provided"}</span>
                      </div>
                      <div className="profile-field">
                        <label>Email:</label>
                        <span>{selectedUser.email || "Not provided"}</span>
                      </div>
                      <div className="profile-field">
                        <label>Company Name:</label>
                        <span>{selectedUser.company_name || "Not provided"}</span>
                      </div>
                      <div className="profile-field">
                        <label>Phone Number:</label>
                        <span>{selectedUser.phone || "Not provided"}</span>
                      </div>
                      <div className="profile-field">
                        <label>GSTIN Number:</label>
                        <span>{selectedUser.gstin || "Not provided"}</span>
                      </div>
                      <div className="profile-field">
                        <label>PAN Number:</label>
                        <span>{selectedUser.pan || "Not provided"}</span>
                      </div>
                    </div>
                  </div>
                )}

                {activeTab === "uploads" && (
                  <div className="uploads-tab">
                    <h2>Upload Files for {selectedUser.username || selectedUser.email}</h2>
                    <div className="upload-sections">
                      <div className="upload-section">
                        <h3>Material Test Certificate (MTC)</h3>
                        <p>Upload MTC files for this user. These will be available to all users.</p>
                        <div className="upload-container">
                          <input
                            type="file"
                            id="mtc-upload"
                            accept=".pdf,.jpg,.jpeg,.png"
                            onChange={(e) => handleFileUpload(e, "mtc")}
                            className="file-input"
                          />
                          <label htmlFor="mtc-upload" className="upload-button">
                            <FaFileUpload /> Select MTC File
                          </label>
                          {uploadProgress.mtc !== null && uploadProgress.mtc !== undefined && (
                            <div className="progress-container">
                              <div className="progress-bar" style={{ width: `${uploadProgress.mtc}%` }}></div>
                              <span className="progress-text">{uploadProgress.mtc}%</span>
                            </div>
                          )}
                        </div>

                        <div className="files-list">
                          <h4>Uploaded MTC Files</h4>
                          {mtcFiles.length > 0 ? (
                            <ul>
                              {mtcFiles.map((file, index) => (
                                <li key={index} className="file-item">
                                  <FaFileAlt className="file-icon" />
                                  <span className="file-name">{file.name}</span>
                                  <div className="file-actions">
                                    <button
                                      onClick={() => window.open(file.url, "_blank")}
                                      className="view-button"
                                      title="View File"
                                    >
                                      <FaEye />
                                    </button>
                                    <button
                                      onClick={() => handleDownload(file.url, file.name)}
                                      className="download-button"
                                      title="Download File"
                                    >
                                      <FaFileDownload />
                                    </button>
                                  </div>
                                </li>
                              ))}
                            </ul>
                          ) : (
                            <p className="no-files">No MTC files uploaded yet</p>
                          )}
                        </div>
                      </div>

                      <div className="upload-section">
                        <h3>User Statements</h3>
                        <p>Upload statement files specific to this user.</p>
                        <div className="upload-container">
                          <input
                            type="file"
                            id="statement-upload"
                            accept=".pdf,.jpg,.jpeg,.png"
                            onChange={(e) => handleFileUpload(e, "statement")}
                            className="file-input"
                          />
                          <label htmlFor="statement-upload" className="upload-button">
                            <FaFileUpload /> Select Statement File
                          </label>
                          {uploadProgress.statement !== null && uploadProgress.statement !== undefined && (
                            <div className="progress-container">
                              <div className="progress-bar" style={{ width: `${uploadProgress.statement}%` }}></div>
                              <span className="progress-text">{uploadProgress.statement}%</span>
                            </div>
                          )}
                        </div>

                        <div className="files-list">
                          <h4>Uploaded Statement Files</h4>
                          {statementFiles.length > 0 ? (
                            <ul>
                              {statementFiles.map((file, index) => (
                                <li key={index} className="file-item">
                                  <FaFileAlt className="file-icon" />
                                  <span className="file-name">{file.name}</span>
                                  <div className="file-actions">
                                    <button
                                      onClick={() => window.open(file.url, "_blank")}
                                      className="view-button"
                                      title="View File"
                                    >
                                      <FaEye />
                                    </button>
                                    <button
                                      onClick={() => handleDownload(file.url, file.name)}
                                      className="download-button"
                                      title="Download File"
                                    >
                                      <FaFileDownload />
                                    </button>
                                  </div>
                                </li>
                              ))}
                            </ul>
                          ) : (
                            <p className="no-files">No statement files uploaded yet</p>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {activeTab === "documents" && (
                  <div className="documents-tab">
                    <h2>User Uploaded Documents</h2>
                    <p>Documents uploaded by {selectedUser.username || selectedUser.email}</p>

                    {Object.keys(userDocuments || {}).length === 0 ? (
                      <p>No documents found</p>
                    ) : (
                      Object.entries(userDocuments || {}).map(([codeId, docs]) => {
                        // Collect required doc sets
                        const requiredDocs = [...REQUIRED_DOCS, ...REQUIRED_CODE_DOCS];

                        // Find missing docs for this CodeID
                        const missingDocs = requiredDocs.filter(doc => !docs[doc]);

                        return (
                          <div key={codeId} className="code-documents">
                            {/* Show CodeID */}
                            <h3 className="code-heading">
                              Code ID: <span className="code-id">{codeId}</span>
                            </h3>

                            {/* Notify button for this whole CodeID */}
                            {missingDocs.length > 0 && (
                              <div className="notify-section">
                                <button
                                  onClick={() =>
                                    sendMissingDocNotification(
                                      selectedUser,
                                      Object.keys(docs).filter((docType) => !docs[docType]).map(formatDocumentName),
                                      codeId
                                    )
                                  }
                                  className="notify-all-button"
                                  title="Notify User for all missing"
                                >
                                  <FaBell /> Notify
                                </button>
                              </div>
                            )}

                            <div className="documents-grid">
                              {Object.keys(docs || {}).map((docType) => (
                                <div key={docType} className="document-card">
                                  <div className="document-icon">{getDocumentIcon(docType)}</div>
                                  <div className="document-info">
                                    <h4>{formatDocumentName(docType)}</h4>
                                    <div className="document-status">
                                      {docs[docType] ? (
                                        <span className="status-uploaded">
                                          <FaCheckCircle className="status-icon uploaded" /> Uploaded
                                        </span>
                                      ) : (
                                        <span className="status-missing">
                                          <FaTimesCircle className="status-icon missing" /> Not Uploaded
                                        </span>
                                      )}
                                    </div>
                                  </div>

                                  {docs[docType] && (
                                    <div className="document-actions">
                                      <button
                                        onClick={() => window.open(docs[docType], "_blank")}
                                        className="view-button"
                                        title="View Document"
                                      >
                                        <FaEye /> View
                                      </button>
                                    </div>
                                  )}
                                </div>
                              ))}
                            </div>
                          </div>
                        );
                      })
                    )}
                  </div>
                )}
                {activeTab === "codeDetails" && (
                  <div className="code-details-tab">
                    <h2>Code Details</h2>
                    <p>Manage code details for {selectedUser.username || selectedUser.email}</p>

                    <div className="code-details-container">
                      <div className="code-cards-section">
                        <h3>User Codes</h3>
                        {loading ? (
                          <div className="loading-indicator">
                            <FaSpinner className="spinner-icon" /> Loading codes...
                          </div>
                        ) : userCodes.length === 0 ? (
                          <div className="no-codes-message">
                            <p>No codes found for this user.</p>
                          </div>
                        ) : (
                          <div className="code-cards">
                            {userCodes.map((code) => (
                              <div key={code.id} className="code-card">
                                <div className="code-header" onClick={() => toggleCodeExpansion(code.id)}>
                                  <div className="code-title">
                                    <span className="code-id">ID: {code.codeID}</span>
                                    <span className="code-brand">Brand: {code.brand}</span>

                                  </div>
                                  <div className="code-actions">
                                    <button
                                      className="edit-button"
                                      onClick={(e) => {
                                        e.stopPropagation()
                                        startEditingCode(code)
                                      }}
                                      title="Edit Code"
                                    >
                                      <FaEdit />
                                    </button>
                                    <button
                                      className="add-site-button"
                                      onClick={(e) => {
                                        e.stopPropagation()
                                        toggleAddingSite(code.id)
                                      }}
                                      title="Add New Site"
                                    >
                                      <FaPlus />
                                    </button>
                                    <button
                                      className="delete-button"
                                      onClick={(e) => {
                                        e.stopPropagation()
                                        deleteCode(code.id)
                                      }}
                                      title="Delete Code"
                                    >
                                      <FaTimesCircle />
                                    </button>
                                    {expandedCodes[code.id] ? (
                                      <FaChevronUp className="expand-icon" />
                                    ) : (
                                      <FaChevronDown className="expand-icon" />
                                    )}
                                  </div>
                                </div>

                                {expandedCodes[code.id] && (
                                  <div className="code-details">
                                    {editingCode === code.id ? (
                                      <div className="code-edit-form">
                                        <div className="code-info">
                                          <div className="info-row">
                                            <label>Code ID:</label>
                                            <input
                                              type="text"
                                              value={editedCodeData.codeID || ""}
                                              onChange={(e) =>
                                                handleEditedCodeChange("codeID", e.target.value.toUpperCase())
                                              }
                                              className="edit-input"
                                              maxLength={20}
                                            />
                                          </div>
                                          <div className="info-row">
                                            <label>Balance:</label>
                                            <input
                                              type="text"
                                              value={editedCodeData.balance || ""}
                                              onChange={(e) => handleEditedCodeChange("balance", e.target.value)}
                                              className="edit-input"
                                            />
                                          </div>
                                          <div className="info-row">
                                            <label>Brand:</label>
                                            <select
                                              value={editedCodeData.brand || ""}
                                              onChange={(e) => handleEditedCodeChange("brand", e.target.value)}
                                              className="edit-input"
                                            >
                                              <option value="">--Select Brand--</option>
                                              <option value="Ultratech">Ultratech</option>
                                              <option value="Shree">Shree</option>
                                              <option value="JSW">JSW</option>
                                              <option value="JKSuper">JKSuper</option>
                                              <option value="ACC">ACC</option>
                                              <option value="Ambuja">Ambuja</option>
                                            </select>
                                          </div>
                                          <div className="info-row">
                                            <label>Cement Site Type:</label>
                                            <select
                                              value={editedCodeData.cementSiteType || ""}
                                              onChange={(e) => handleEditedCodeChange("cementSiteType", e.target.value)}
                                              className="edit-input">
                                              <option value="">--Select cement Type--</option>
                                              <option value="EX">EX</option>
                                              <option value="FOR">FOR</option>
                                            </select>
                                          </div>
                                          <div className="info-row">
                                            <label>Depot Name:</label>
                                            <select
                                              value={editedCodeData.depoName || ""}
                                              onChange={(e) => handleEditedCodeChange("depoName", e.target.value)}
                                              className="edit-input"
                                            >
                                              <option value="">--Select Depot--</option>
                                              {depots.filter(depot => depot.brandName === editedCodeData.brand).map((depot) => (
                                                <option key={depot.id} value={depot.depoName}>
                                                  {depot.depoName}
                                                </option>
                                              ))}
                                            </select>
                                          </div>
                                        </div>

                                        <div className="depo-account-section">
                                          <h5>Depot Account Details</h5>
                                          <div className="depo-account-details">
                                            <div className="info-row">
                                              <label>Account Number:</label>
                                              <input
                                                type="text"
                                                value={editedCodeData.depoAccount?.AccountNumber || ""}
                                                onChange={(e) =>
                                                  handleEditedCodeChange(
                                                    "depoAccount.AccountNumber",
                                                    e.target.value.toUpperCase(),
                                                  )
                                                }
                                                className="edit-input"
                                                maxLength={25}
                                              />
                                            </div>
                                            <div className="info-row">
                                              <label>Beneficiary Name:</label>
                                              <input
                                                type="text"
                                                value={editedCodeData.depoAccount?.BeneficiaryName || ""}
                                                onChange={(e) =>
                                                  handleEditedCodeChange("depoAccount.BeneficiaryName", e.target.value)
                                                }
                                                className="edit-input"
                                                maxLength={50}
                                              />
                                            </div>
                                            <div className="info-row">
                                              <label>IFSC Code:</label>
                                              <input
                                                type="text"
                                                value={editedCodeData.depoAccount?.IFSC || ""}
                                                onChange={(e) =>
                                                  handleEditedCodeChange(
                                                    "depoAccount.IFSC",
                                                    e.target.value.toUpperCase(),
                                                  )
                                                }
                                                className="edit-input"
                                                maxLength={11}
                                              />
                                            </div>
                                            <div className="info-row">
                                              <label>Bank & Branch:</label>
                                              <input
                                                type="text"
                                                value={editedCodeData.depoAccount?.Branch || ""}
                                                onChange={(e) =>
                                                  handleEditedCodeChange("depoAccount.Branch", e.target.value)
                                                }
                                                className="edit-input"
                                              />
                                            </div>
                                          </div>
                                        </div>

                                        <div className="edit-actions">
                                          <button className="cancel-button" onClick={cancelEditingCode}>
                                            Cancel
                                          </button>
                                          <button className="save-button" onClick={saveEditedCode}>
                                            Save Changes
                                          </button>
                                        </div>
                                      </div>
                                    ) : (
                                      <>
                                        <div className="code-info">
                                          <div className="info-row">
                                            <label>Code ID:</label>
                                            <span>{code.codeID || "N/A"}</span>
                                          </div>
                                          <div className="info-row">
                                            <label>Balance:</label>
                                            <span>{code.balance || "to be updated"}</span>
                                          </div>
                                          <div className="info-row">
                                            <label>Brand:</label>
                                            <span>{code.brand || "N/A"}</span>
                                          </div>
                                          <div className="info-row">
                                            <label>Cement Site Type:</label>
                                            <span>{code.cementSiteType || "N/A"}</span>
                                          </div>
                                          <div className="info-row">
                                            <label>Depot Name:</label>
                                            <span>{code.depoName || "N/A"}</span>
                                          </div>
                                        </div>

                                        <div className="depo-account-section">
                                          <h5>Depot Account Details</h5>
                                          {code.depoAccount ? (
                                            <div className="depo-account-details">
                                              <div className="info-row">
                                                <label>Account Number:</label>
                                                <span>{code.depoAccount.AccountNumber || "N/A"}</span>
                                              </div>
                                              <div className="info-row">
                                                <label>Beneficiary Name:</label>
                                                <span>{code.depoAccount.BeneficiaryName || "N/A"}</span>
                                              </div>
                                              <div className="info-row">
                                                <label>IFSC Code:</label>
                                                <span>{code.depoAccount.IFSC || "N/A"}</span>
                                              </div>
                                              <div className="info-row">
                                                <label>Bank & Branch:</label>
                                                <span>{code.depoAccount.Branch || "N/A"}</span>
                                              </div>
                                            </div>
                                          ) : (
                                            <p className="no-data">No depot account details available</p>
                                          )}
                                        </div>

                                        <div className="sites-section">
                                          <h5>Site Addresses</h5>
                                          {code.sites && Object.keys(code.sites).length > 0 ? (
                                            <div className="sites-list">
                                              {Object.entries(code.sites).map(([siteKey, siteData]) => (
                                                <div key={siteKey} className="site-item">
                                                  <div className="site-header">
                                                    <span className="site-number">Site {siteKey}</span>
                                                  </div>
                                                  <div className="site-details">
                                                    <div className="info-row">
                                                      <label>Address:</label>
                                                      <span>{siteData.address || "N/A"}</span>
                                                    </div>
                                                    <div className="info-row">
                                                      <label>State:</label>
                                                      <span>{siteData.state || "N/A"}</span>
                                                    </div>
                                                    <div className="info-row">
                                                      <label>Pincode:</label>
                                                      <span>{siteData.pincode || "N/A"}</span>
                                                    </div>
                                                  </div>
                                                </div>
                                              ))}
                                            </div>
                                          ) : (
                                            <p className="no-data">No site addresses available</p>
                                          )}
                                        </div>
                                      </>
                                    )}
                                    {addingSiteToCode === code.id && (
                                      <div className="add-site-form">
                                        <h5>Add New Site</h5>

                                        {/* Copied Addresses Dropdown for New Site */}
                                        {copiedAddresses.length > 0 && (
                                          <div className="copied-addresses-section">
                                            <button
                                              type="button"
                                              className="use-copied-address-btn"
                                              onClick={() => setShowNewSiteAddressDropdown(!showNewSiteAddressDropdown)}
                                            >
                                              <FaMapMarkerAlt /> Use Copied Address ({copiedAddresses.length})
                                            </button>

                                            {showNewSiteAddressDropdown && (
                                              <div className="copied-addresses-dropdown">
                                                <div className="dropdown-header">
                                                  <span>Select from copied addresses:</span>
                                                  <button
                                                    type="button"
                                                    className="close-dropdown-btn"
                                                    onClick={() => setShowNewSiteAddressDropdown(false)}
                                                  >
                                                    ×
                                                  </button>
                                                </div>
                                                <div className="addresses-list">
                                                  {copiedAddresses.map((addr, index) => (
                                                    <div key={index} className="address-item">
                                                      <div
                                                        className="address-content"
                                                        onClick={() => handleAddressClickForNewSite(addr)}
                                                      >
                                                        <div className="address-main">
                                                          <strong>{addr.address}</strong>
                                                        </div>
                                                        <div className="address-details">
                                                          {addr.state}
                                                          {addr.pincode && `, ${addr.pincode}`}
                                                        </div>
                                                        <div className="address-meta">
                                                          {addr.companyName && (
                                                            <span className="company">{addr.companyName}</span>
                                                          )}
                                                          {addr.brand && <span className="brand">{addr.brand}</span>}
                                                        </div>
                                                      </div>
                                                      <button
                                                        type="button"
                                                        className="remove-address-btn"
                                                        onClick={(e) => {
                                                          e.stopPropagation()
                                                          clearCopiedAddress(index)
                                                        }}
                                                        title="Remove this address"
                                                      >
                                                        <FaTrash />
                                                      </button>
                                                    </div>
                                                  ))}
                                                </div>
                                              </div>
                                            )}
                                          </div>
                                        )}

                                        <div className="site-form-fields">
                                          <div className="form-group">
                                            <label>Address</label>
                                            <input
                                              type="text"
                                              value={newSiteForm.address}
                                              onChange={(e) => handleNewSiteChange("address", e.target.value)}
                                              placeholder="Enter address"
                                              className="form-control"
                                            />
                                          </div>
                                          <div className="form-group">
                                            <label>State</label>
                                            <select
                                              value={newSiteForm.state}
                                              onChange={(e) => handleNewSiteChange("state", e.target.value)}
                                              className="form-control"
                                            >
                                              <option value="">--Select State--</option>
                                              {indianStates.map((state) => (
                                                <option key={state} value={state}>
                                                  {state}
                                                </option>
                                              ))}
                                            </select>
                                          </div>
                                          <div className="form-group">
                                            <label>Pincode (Optional)</label>
                                            <input
                                              type="text"
                                              value={newSiteForm.pincode}
                                              onChange={(e) => handleNewSiteChange("pincode", e.target.value)}
                                              placeholder="Enter 6-digit pincode"
                                              className="form-control"
                                              maxLength={6}
                                              pattern="\d{6}"
                                            />
                                          </div>
                                        </div>

                                        <div className="form-actions">
                                          <button className="cancel-button" onClick={() => setAddingSiteToCode(null)}>
                                            Cancel
                                          </button>
                                          <button
                                            className="submit-button"
                                            onClick={() => addNewSiteToCode(code.id)}
                                            disabled={!newSiteForm.address || !newSiteForm.state}
                                          >
                                            Add Site
                                          </button>
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                )}
                              </div>
                            ))}
                          </div>
                        )}
                      </div>

                      <div className="new-code-form-section">
                        <h3>Add New Code</h3>

                        {/* Copied Addresses Management */}
                        {copiedAddresses.length > 0 && (
                          <div className="copied-addresses-management">
                            <div className="addresses-header">
                              <h4>
                                <FaMapMarkerAlt /> Copied Site Addresses ({copiedAddresses.length})
                              </h4>
                              <button
                                type="button"
                                className="clear-all-btn"
                                onClick={clearAllCopiedAddresses}
                                title="Clear all copied addresses"
                              >
                                Clear All
                              </button>
                            </div>
                            <p className="addresses-info">
                              These addresses were copied from Current Rates. Click on any address to use it in the form
                              below.
                            </p>
                          </div>
                        )}

                        <div className="new-code-form">
                          <div className={`form-group ${!validation.codeID?.isValid ? "has-error" : ""}`}>
                            <label>
                              Code ID <span className="required">*</span>
                            </label>
                            <input
                              type="text"
                              value={newCodeForm.codeID}
                              onChange={(e) => handleNewCodeChange("codeID", e.target.value.toUpperCase())}
                              placeholder="Enter code (max 20 chars, uppercase letters & digits only)"
                              className="form-control"
                              maxLength={20}
                            />
                            {!validation.codeID?.isValid && (
                              <div className="validation-error">{validation.codeID?.message}</div>
                            )}
                          </div>

                          <div className={`form-group ${!validation.brand?.isValid ? "has-error" : ""}`}>
                            <label>
                              Brand <span className="required">*</span>
                            </label>
                            <select
                              value={newCodeForm.brand}
                              onChange={(e) => handleNewCodeChange("brand", e.target.value)}
                              className="form-control"
                            >
                              <option value="">--Select Brand--</option>
                              <option value="Ultratech">Ultratech</option>
                              <option value="Shree">Shree</option>
                              <option value="JSW">JSW</option>
                              <option value="JKSuper">JKSuper</option>
                              <option value="ACC">ACC</option>
                              <option value="Ambuja">Ambuja</option>
                            </select>
                            {!validation.brand?.isValid && (
                              <div className="validation-error">{validation.brand?.message}</div>
                            )}
                          </div>

                          <div className={`form-group ${!validation.brand?.isValid ? "has-error" : ""}`}>
                            <label>
                              Cement Site Type<span className="required">*</span>
                            </label>
                            <select
                              value={newCodeForm.cementSiteType}
                              onChange={(e) => handleNewCodeChange("cementSiteType", e.target.value)}
                              className="form-control"
                            >
                              <option value="">--Select Cement Site Type--</option>
                              <option value="EX">EX</option>
                              <option value="FOR">FOR</option>
                            </select>
                            {!validation.brand?.isValid && (
                              <div className="validation-error">{validation.brand?.message}</div>
                            )}
                          </div>

                          {newCodeForm.brand && depots.filter(depot => depot.brandName === newCodeForm.brand).length > 0 && (
                            <div className={`form-group ${!validation.depoName?.isValid ? "has-error" : ""}`}>
                              <label>
                                Depot Name <span className="required">*</span>
                              </label>
                              <select
                                value={newCodeForm.depoName}
                                onChange={(e) => handleNewCodeChange("depoName", e.target.value)}
                                className="form-control"
                              >
                                <option value="">--Select Depot--</option>
                                {depots.filter(depot => depot.brandName === newCodeForm.brand).map((depot) => (
                                  <option key={depot.id} value={depot.depoName}>
                                    {depot.depoName}
                                  </option>
                                ))}
                              </select>
                              {!validation.depoName?.isValid && (
                                <div className="validation-error">{validation.depoName?.message}</div>
                              )}
                            </div>
                          )}

                          <div className="form-group">
                            <label>Balance</label>
                            <input
                              type="number"
                              value={newCodeForm.balance || ""}
                              onChange={(e) => handleNewCodeChange("balance", e.target.value)}
                              placeholder="Enter balance amount"
                              className="form-control"
                              disabled
                            />
                          </div>


                          <div className="form-section">
                            <h4>Depot Account Details</h4>
                            <div className={`form-group ${!validation.depoAccount?.isValid ? "has-error" : ""}`}>
                              <label>
                                Account Number <span className="required">*</span>
                              </label>
                              <input
                                type="text"
                                value={newCodeForm.depoAccount.AccountNumber}
                                onChange={(e) =>
                                  handleNewCodeChange("depoAccount.AccountNumber", e.target.value.toUpperCase())
                                }
                                placeholder="Enter account number (max 25 chars, uppercase & digits only)"
                                className="form-control"
                                maxLength={25}
                              />
                              {!validation.depoAccount?.isValid &&
                                validation.depoAccount?.message.includes("Account number") && (
                                  <div className="validation-error">{validation.depoAccount?.message}</div>
                                )}
                            </div>

                            <div className={`form-group ${!validation.depoAccount?.isValid ? "has-error" : ""}`}>
                              <label>
                                Beneficiary Name <span className="required">*</span>
                              </label>
                              <input
                                type="text"
                                value={newCodeForm.depoAccount.BeneficiaryName}
                                onChange={(e) => handleNewCodeChange("depoAccount.BeneficiaryName", e.target.value)}
                                placeholder="Enter beneficiary name (max 50 chars, letters only)"
                                className="form-control"
                                maxLength={50}
                              />
                              {!validation.depoAccount?.isValid &&
                                validation.depoAccount?.message.includes("Beneficiary name") && (
                                  <div className="validation-error">{validation.depoAccount?.message}</div>
                                )}
                            </div>

                            <div className={`form-group ${!validation.depoAccount?.isValid ? "has-error" : ""}`}>
                              <label>
                                IFSC Code <span className="required">*</span>
                              </label>
                              <input
                                type="text"
                                value={newCodeForm.depoAccount.IFSC}
                                onChange={(e) => handleNewCodeChange("depoAccount.IFSC", e.target.value.toUpperCase())}
                                placeholder="Enter IFSC code (format: AAAA0XXXXXX)"
                                className="form-control"
                                maxLength={11}
                              />
                              {!validation.depoAccount?.isValid &&
                                validation.depoAccount?.message.includes("IFSC code") && (
                                  <div className="validation-error">{validation.depoAccount?.message}</div>
                                )}
                            </div>

                            <div className={`form-group ${!validation.depoAccount?.isValid ? "has-error" : ""}`}>
                              <label>
                                Bank & Branch <span className="required">*</span>
                              </label>
                              <input
                                type="text"
                                value={newCodeForm.depoAccount.Branch}
                                onChange={(e) => handleNewCodeChange("depoAccount.Branch", e.target.value)}
                                placeholder="Enter bank name and branch"
                                className="form-control"
                                maxLength={100}
                              />
                              {!validation.depoAccount?.isValid &&
                                validation.depoAccount?.message.includes("Bank name") && (
                                  <div className="validation-error">{validation.depoAccount?.message}</div>
                                )}
                            </div>
                          </div>

                          <div className="form-section">
                            <h4>Site Address</h4>

                            {/* Copied Addresses Dropdown */}
                            {copiedAddresses.length > 0 && (
                              <div className="copied-addresses-section">
                                <button
                                  type="button"
                                  className="use-copied-address-btn"
                                  onClick={() => setShowAddressDropdown(!showAddressDropdown)}
                                >
                                  <FaMapMarkerAlt /> Use Copied Address ({copiedAddresses.length})
                                </button>

                                {showAddressDropdown && (
                                  <div className="copied-addresses-dropdown">
                                    <div className="dropdown-header">
                                      <span>Select from copied addresses:</span>
                                      <button
                                        type="button"
                                        className="close-dropdown-btn"
                                        onClick={() => setShowAddressDropdown(false)}
                                      >
                                        ×
                                      </button>
                                    </div>
                                    <div className="addresses-list">
                                      {copiedAddresses.map((addr, index) => (
                                        <div key={index} className="address-item">
                                          <div className="address-content" onClick={() => handleAddressClick(addr)}>
                                            <div className="address-main">
                                              <strong>{addr.address}</strong>
                                            </div>
                                            <div className="address-details">
                                              {addr.state}
                                              {addr.pincode && `, ${addr.pincode}`}
                                            </div>
                                            <div className="address-meta">
                                              {addr.companyName && <span className="company">{addr.companyName}</span>}
                                              {addr.brand && <span className="brand">{addr.brand}</span>}
                                              <span className="timestamp">
                                                {new Date(addr.timestamp).toLocaleDateString()}
                                              </span>
                                            </div>
                                          </div>
                                          <button
                                            type="button"
                                            className="remove-address-btn"
                                            onClick={(e) => {
                                              e.stopPropagation()
                                              clearCopiedAddress(index)
                                            }}
                                            title="Remove this address"
                                          >
                                            <FaTrash />
                                          </button>
                                        </div>
                                      ))}
                                    </div>
                                  </div>
                                )}
                              </div>
                            )}

                            <div className={`form-group ${!validation.sites?.isValid ? "has-error" : ""}`}>
                              <label>
                                Address <span className="required">*</span>
                              </label>
                              <input
                                type="text"
                                value={newCodeForm.sites[1].address}
                                onChange={(e) => handleNewCodeSiteChange("address", e.target.value)}
                                placeholder="Enter address"
                                className="form-control"
                              />
                            </div>

                            <div className={`form-group ${!validation.sites?.isValid ? "has-error" : ""}`}>
                              <label>
                                State <span className="required">*</span>
                              </label>
                              <select
                                value={newCodeForm.sites[1].state}
                                onChange={(e) => handleNewCodeSiteChange("state", e.target.value)}
                                className="form-control"
                              >
                                <option value="">--Select State--</option>
                                {indianStates.map((state) => (
                                  <option key={state} value={state}>
                                    {state}
                                  </option>
                                ))}
                              </select>
                            </div>

                            <div className="form-group">
                              <label>Pincode (Optional)</label>
                              <input
                                type="text"
                                value={newCodeForm.sites[1].pincode}
                                onChange={(e) => handleNewCodeSiteChange("pincode", e.target.value)}
                                placeholder="Enter 6-digit pincode"
                                className="form-control"
                                maxLength={6}
                                pattern="\d{6}"
                              />
                            </div>


                            {!validation.sites?.isValid && (
                              <div className="validation-error">{validation.sites?.message}</div>
                            )}
                          </div>

                          <div className="form-actions">
                            <button className="submit-button" onClick={handleSubmitNewCode} disabled={loading}>
                              {loading ? (
                                <>
                                  <FaSpinner className="spinner-icon" /> Submitting...
                                </>
                              ) : (
                                <>
                                  <FaSave className="button-icon" /> Add New Code
                                </>
                              )}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {activeTab === "orderHistory" && (
                  <div className="order-history-tab">
                    <h2>Order History</h2>
                    <p>Order history for {selectedUser.username || selectedUser.email}</p>

                    <div className="pending-orders-count">
                      <span>Pending Orders: {pendingOrdersCount}</span>
                    </div>

                    {loading ? (
                      <div className="loading-indicator">
                        <FaSpinner className="spinner-icon" /> Loading order history...
                      </div>
                    ) : orderHistory.length === 0 ? (
                      <div className="no-orders-message">
                        <p>No orders found for this user.</p>
                      </div>
                    ) : (
                      <div className="order-table-wrapper">
                        <table className="order-table">
                          <thead>
                            <tr>
                              <th>Code ID</th>
                              <th>Date</th>
                              <th>Brand</th>
                              <th>Quantity</th>
                              <th>Site Address</th>
                              <th>Status</th>
                            </tr>
                          </thead>
                          <tbody>
                            {orderHistory.map((order) => (
                              <tr key={order.id}>
                                <td>{order.code}</td>
                                <td>
                                  {order.timestamp
                                    ? new Date(order.timestamp).toLocaleDateString("en-GB", {
                                      day: "2-digit",
                                      month: "short",
                                      year: "numeric",
                                    })
                                    : "N/A"}
                                </td>

                                <td>{order.brand || "N/A"}</td>
                                <td>{order.quantity || "N/A"}</td>
                                <td>
                                  {order.siteAddress?.address
                                    ? `${order.siteAddress.address}, ${order.siteAddress.state}${order.siteAddress.pincode
                                      ? `, ${order.siteAddress.pincode}`
                                      : ""
                                    }`
                                    : "N/A"}
                                </td>
                                <td>
                                  <span className={`order-status ${order.status}`}>
                                    {order.status.charAt(0).toUpperCase() + order.status.slice(1)}
                                  </span>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    )}
                  </div>
                )}

                {activeTab === "poDetails" && (
                  <div className="po-details-tab">
                    <h2>Purchase Order Details</h2>
                    <p>Manage PO details for {selectedUser.username || selectedUser.email}. POs can be updated by supplier.</p>

                    <div className="po-details-container">
                      <div className="po-cards-section">
                        <h3>User POs</h3>
                        {loading ? (
                          <div className="loading-indicator">
                            <FaSpinner className="spinner-icon" /> Loading POs...
                          </div>
                        ) : poList.length === 0 ? (
                          <div className="no-pos-message">
                            <p>No POs found for this user.</p>
                          </div>
                        ) : (
                          <div className="po-cards">
                            {poList.map((po) => (
                              <div key={po.id} className="po-card">
                                <div className="po-header" onClick={() => togglePOExpansion(po.id)}>
                                  <div className="po-title">
                                    <span className="po-number">PO: {po.poNumber}</span>
                                    <span className="po-status">{po.status}</span>
                                  </div>
                                  <div className="po-actions">
                                    <button
                                      className="edit-button"
                                      onClick={(e) => { e.stopPropagation(); startEditingPO(po); }}
                                      title="Edit PO">
                                      <FaEdit />
                                    </button>
                                    <button
                                      className="delete-button"
                                      onClick={(e) => { e.stopPropagation(); deletePO(po.id); }}
                                      title="Delete PO"
                                    >
                                      <FaTrash />
                                    </button>
                                    {expandedPOs[po.id] ? (
                                      <FaChevronUp className="expand-icon" />
                                    ) : (
                                      <FaChevronDown className="expand-icon" />
                                    )}
                                  </div>
                                </div>

                                {expandedPOs[po.id] && (
                                  <div className="po-details">
                                    {editingPO === po.id ? (
                                      <div className="po-edit-form">
                                        <div className="form-group">
                                          <label>Basic Price of Material</label>
                                          <input
                                            type="number"
                                            value={editedPOData.basicPrice}
                                            onChange={(e) => handleEditedPOChange("basicPrice", e.target.value)}
                                            placeholder="Enter Basic Price"
                                            onWheel={(e) => { e.target.blur(); }}
                                          />
                                        </div>

                                        <div className="form-group">
                                          <label>GST Percentage</label>
                                          <input
                                            type="number"
                                            value={editedPOData.gstPercentage}
                                            onChange={(e) => handleEditedPOChange("gstPercentage", e.target.value)}
                                            placeholder="Enter GST percentage"
                                            onWheel={(e) => { e.target.blur(); }}
                                          />
                                        </div>

                                        <div className="form-group">
                                          <label>Calculated GST</label>
                                          <input
                                            type="number"
                                            value={
                                              editedPOData.basicPrice && editedPOData.gstPercentage
                                                ? (Number(editedPOData.basicPrice) * Number(editedPOData.gstPercentage)) / 100
                                                : ""
                                            }
                                            readOnly
                                          />
                                        </div>

                                        <div className="form-group">
                                          <label>Total Billing Price/Bag</label>
                                          <input
                                            type="number"
                                            value={editedPOData.totalPrice}
                                            onChange={(e) => handleEditedPOChange("totalPrice", e.target.value)}
                                            placeholder="Enter total price"
                                            onWheel={(e) => { e.target.blur(); }}
                                          />
                                        </div>

                                        <div className="form-group">
                                          <label>Packaging</label>
                                          <input
                                            type="text"
                                            value={editedPOData.packaging}
                                            onChange={(e) => handleEditedPOChange("packaging", e.target.value)}
                                          />
                                        </div>
                                        <div className="form-group">
                                          <label>GST No</label>
                                          <input
                                            type="text"
                                            value={editedPOData.gstNo}
                                            onChange={(e) => handleEditedPOChange("gstNo", e.target.value)}
                                          />
                                        </div>
                                        <div className="form-group">
                                          <label>PAN No</label>
                                          <input
                                            type="text"
                                            value={editedPOData.panNo}
                                            onChange={(e) => handleEditedPOChange("panNo", e.target.value)}
                                          />
                                        </div>
                                        <div className="form-group">
                                          <label>Payment Terms</label>
                                          <input
                                            type="text"
                                            value={editedPOData.paymentTerms}
                                            onChange={(e) => handleEditedPOChange("paymentTerms", e.target.value)}
                                          />
                                        </div>
                                        <div className="form-group">
                                          <label>Billing Address</label>
                                          <input
                                            type="text"
                                            value={editedPOData.billingAddress}
                                            onChange={(e) => handleEditedPOChange("billingAddress", e.target.value)}
                                          />
                                        </div>
                                        <div className="form-group">
                                          <label>Site Address</label>
                                          <input
                                            type="text"
                                            value={editedPOData.siteAddress.address || ""}
                                            onChange={(e) => handleEditedPOSiteChange("address", e.target.value)}
                                          />
                                        </div>
                                        <div className="form-group">
                                          <label>Site State</label>
                                          <input
                                            type="text"
                                            value={editedPOData.siteAddress.state || ""}
                                            onChange={(e) => handleEditedPOSiteChange("state", e.target.value)}
                                          />
                                        </div>
                                        <div className="form-group">
                                          <label>Site Pincode</label>
                                          <input
                                            type="text"
                                            value={editedPOData.siteAddress.pincode || ""}
                                            onChange={(e) => handleEditedPOSiteChange("pincode", e.target.value)}
                                          />
                                        </div>
                                        <div className="form-group">
                                          <label>Contact Person</label>
                                          <input
                                            type="text"
                                            value={editedPOData.contactPerson}
                                            onChange={(e) => handleEditedPOChange("contactPerson", e.target.value)}
                                          />
                                        </div>
                                        <div className="form-group">
                                          <label>Contact Mobile</label>
                                          <input
                                            type="text"
                                            value={editedPOData.contactMobile}
                                            onChange={(e) => handleEditedPOChange("contactMobile", e.target.value)}
                                          />
                                        </div>
                                        <div className="form-group">
                                          <label>Delivery Schedule</label>
                                          <input
                                            type="text"
                                            value={editedPOData.deliverySchedule}
                                            onChange={(e) => handleEditedPOChange("deliverySchedule", e.target.value)}
                                          />
                                        </div>
                                        <div className="form-group">
                                          <label>End Use of Cement</label>
                                          <input
                                            type="text"
                                            value={editedPOData.endUse}
                                            onChange={(e) => handleEditedPOChange("endUse", e.target.value)}
                                          />
                                        </div>
                                        <div className="form-group">
                                          <label>Category</label>
                                          <input
                                            type="text"
                                            value={editedPOData.category}
                                            onChange={(e) => handleEditedPOChange("category", e.target.value)}
                                          />
                                        </div>
                                        <div className="form-group">
                                          <label>Email</label>
                                          <input
                                            type="email"
                                            value={editedPOData.email}
                                            onChange={(e) => handleEditedPOChange("email", e.target.value)}
                                          />
                                        </div>
                                        <div className="form-group">
                                          <label>TPC Code</label>
                                          <input
                                            type="text"
                                            value={editedPOData.tpcCode}
                                            onChange={(e) => handleEditedPOChange("tpcCode", e.target.value)}
                                            onWheel={(e) => { e.target.blur(); }}
                                          />
                                        </div>
                                        <div className="form-group">
                                          <label>Brand</label>
                                          <select
                                            value={editedPOData.brand}
                                            onChange={(e) => handleEditedPOChange("brand", e.target.value)}
                                          >
                                            <option value="">--Select Brand--</option>
                                            <option value="Ultratech">Ultratech</option>
                                            <option value="Shree">Shree</option>
                                            <option value="JSW">JSW</option>
                                            <option value="JKSuper">JKSuper</option>
                                            <option value="ACC">ACC</option>
                                            <option value="Ambuja">Ambuja</option>
                                          </select>
                                        </div>
                                        <div className="form-group">
                                          <label>Company Name</label>
                                          <input
                                            type="text"
                                            value={editedPOData.companyName}
                                            onChange={(e) => handleEditedPOChange("companyName", e.target.value)}
                                          />
                                        </div>
                                        <div className="form-group">
                                          <label>Quantity Type(Bags/MT)</label>
                                          <input
                                            type="text"
                                            value={editedPOData.quantityType}
                                            onChange={(e) => handleEditedPOChange("quantityType", e.target.value)}
                                            onWheel={(e) => { e.target.blur(); }}
                                          />
                                        </div>
                                        <div className="form-group">
                                          <label>Rate</label>
                                          <input
                                            type="number"
                                            value={editedPOData.rate}
                                            onChange={(e) => handleEditedPOChange("rate", e.target.value)}
                                            onWheel={(e) => { e.target.blur(); }}
                                          />
                                        </div>

                                        <div className="form-group">
                                          <label>Status</label>
                                          <select
                                            value={editedPOData.status}
                                            onChange={(e) => handleEditedPOChange("status", e.target.value)}
                                          >
                                            <option value="active">Active</option>
                                            <option value="Pending">Pending</option>
                                            <option value="Completed">Completed</option>
                                            <option value="expired">Expired</option>
                                          </select>
                                        </div>
                                        <div className="edit-actions">
                                          <button className="cancel-button" onClick={cancelEditingPO}>
                                            Cancel
                                          </button>
                                          <button className="save-button" onClick={saveEditedPO}>
                                            Save Changes
                                          </button>
                                        </div>
                                      </div>
                                    ) : (
                                      <>
                                        <div className="info-row">
                                          <label>PO Number:</label>
                                          <span>{po.poNumber || "N/A"}</span>
                                        </div>
                                        <div className="info-row">
                                          <label>Quantity:</label>
                                          <span>{po.quantity || "N/A"}</span>
                                        </div>
                                        <div className="info-row">
                                          <label>Grade:</label>
                                          <span>{po.grade || "N/A"}</span>
                                        </div>
                                        <div className="info-row">
                                          <label>Cement Site Type:</label>
                                          <span>{po.cementSiteType || "N/A"}</span>
                                        </div>
                                        <div className="info-row">
                                          <label>Site Address:</label>
                                          <span>{po.siteAddress.address || "N/A"}</span>
                                        </div>
                                        <div className="info-row">
                                          <label>Site State:</label>
                                          <span>{po.siteAddress.state || "N/A"}</span>
                                        </div>
                                        <div className="info-row">
                                          <label>Site Pincode:</label>
                                          <span>{po.siteAddress.pincode || "N/A"}</span>
                                        </div>
                                        <div className="info-row">
                                          <label>Creation Date:</label>
                                          <span>{po.creationDate || po.timestamp ? new Date(po.creationDate || po.timestamp).toLocaleDateString() : "N/A"}</span>
                                        </div>
                                        <div className="info-row">
                                          <label>Brand:</label>
                                          <span>{po.brand || "N/A"}</span>
                                        </div>
                                        <div className="info-row">
                                          <label>CodeID:</label>
                                          <span>{po.code || "N/A"}</span>
                                        </div>
                                        <div className="info-row">
                                          <label>Company Name:</label>
                                          <span>{po.companyName || "N/A"}</span>
                                        </div>
                                        <div className="info-row">
                                          <label>Quantity Type:</label>
                                          <span>{po.quantityType || "N/A"}</span>
                                        </div>
                                        <div className="info-row">
                                          <label>Rate:</label>
                                          <span>{po.rate || "N/A"}</span>
                                        </div>
                                      </>
                                    )}
                                  </div>
                                )}
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                      {/* <div className="form-group">
            <label>PO Number</label>
            <input
              type="text"
              value={newPOForm.poNumber}
              onChange={(e) => handleNewPOChange("poNumber", e.target.value)}
              placeholder="Enter PO number"
            />
          </div> */}

                      <div className="new-po-form-section">
                        <h3>Add New PO</h3>
                        <div className="new-po-form">
                          <div className="form-group">
                            <label>Code</label>
                            <select
                              value={newPOForm.code}
                              onChange={(e) => handleNewPOChange("code", e.target.value)}
                            >
                              <option value="">--Select Code--</option>
                              {userCodes.map((code) => (
                                <option key={code.id} value={code.codeID}>
                                  {code.codeID}
                                </option>
                              ))}
                            </select>
                            {formErrors.code && <div className="error-message">{formErrors.code}</div>}

                          </div>
                          <div className="form-group">
                            <label>POID</label>
                            <select
                              value={newPOForm.poNumber}
                              onChange={(e) => handleSelectPO(e.target.value)}
                            >
                              <option value="">--Select POID--</option>
                              {poList.map((po) => (
                                <option key={po.id} value={po.id}>
                                  {po.id}
                                </option>
                              ))}
                            </select>
                            {formErrors.poNumber && <div className="error-message">{formErrors.poNumber}</div>}
                          </div>

                          <div className="form-group">
                            <label>Grade</label>
                            <input
                              type="text"
                              value={newPOForm.grade}
                              onChange={(e) => handleNewPOChange("grade", e.target.value)}
                              placeholder="Enter grade"
                            />
                            {formErrors.grade && <div className="error-message">{formErrors.grade}</div>}
                          </div>


                          <div className="form-group">
                            <label>Cement Site Type:</label>
                            <select
                              value={newPOForm.cementSiteType || ""}
                              onChange={(e) => handleNewPOChange("cementSiteType", e.target.value)}
                              className="edit-input">
                              <option value="">--Select cement Type--</option>
                              <option value="EX">EX</option>
                              <option value="FOR">FOR</option>
                            </select>
                          </div>

                          <div className="form-group">
                            <label>Quantity</label>
                            <input
                              type="number"
                              value={newPOForm.quantity}
                              onChange={(e) => handleNewPOChange("quantity", e.target.value)}
                              placeholder="Enter quantity"
                              onWheel={(e) => { e.target.blur(); }}
                            />
                            {formErrors.quantity && <div className="error-message">{formErrors.quantity}</div>}

                          </div>
                          <div className="form-group">
                            <label>Rate</label>
                            <input
                              type="number"
                              value={newPOForm.rate}
                              onChange={(e) => handleNewPOChange("rate", e.target.value)}
                              placeholder="Enter rate"
                              onWheel={(e) => { e.target.blur(); }}
                            />
                            {formErrors.rate && <div className="error-message">{formErrors.rate}</div>}

                          </div>

                          <div className="form-group">
                            <label>Site Address</label>
                            <input
                              type="text"
                              value={newPOForm.siteAddress.address}
                              onChange={(e) => handleNewPOSiteChange("address", e.target.value)}
                              placeholder="Enter site address"
                            />
                            {formErrors.address && <div className="error-message">{formErrors.address}</div>}

                          </div>

                          <div className="form-group">
                            <label>Site State</label>
                            <input
                              type="text"
                              value={newPOForm.siteAddress.state}
                              onChange={(e) => handleNewPOSiteChange("state", e.target.value)}
                              placeholder="Enter site state"
                            />
                            {formErrors.state && <div className="error-message">{formErrors.state}</div>}
                          </div>

                          <div className="form-group">
                            <label>Site Pincode</label>
                            <input
                              type="text"
                              value={newPOForm.siteAddress.pincode}
                              onChange={(e) => handleNewPOSiteChange("pincode", e.target.value)}
                              placeholder="Enter site pincode"
                              onWheel={(e) => { e.target.blur(); }}
                            />
                            {formErrors.pincode && <div className="error-message">{formErrors.pincode}</div>}

                          </div>
                          <div className="form-group">
                            <label>Basic Price of Material</label>
                            <input
                              type="number"
                              value={newPOForm.basicPrice}
                              onChange={(e) => handleNewPOChange("basicPrice", e.target.value)}
                              placeholder="Enter Basic Price"
                              onWheel={(e) => { e.target.blur(); }}
                            />
                            {formErrors.basicPrice && <div className="error-message">{formErrors.basicPrice}</div>}
                          </div>

                          <div className="form-group">
                            <label>GST Percentage</label>
                            <input
                              type="number"
                              value={newPOForm.gstPercentage}
                              onChange={(e) => handleNewPOChange("gstPercentage", e.target.value)}
                              placeholder="Enter GST percentage"
                              onWheel={(e) => { e.target.blur(); }}
                            />
                            {formErrors.gstPercentage && <div className="error-message">{formErrors.gstPercentage}</div>}
                          </div>

                          <div className="form-group">
                            <label>Calculated GST</label>
                            <input
                              type="number"
                              value={
                                newPOForm.basicPrice && newPOForm.gstPercentage
                                  ? (Number(newPOForm.basicPrice) * Number(newPOForm.gstPercentage)) / 100
                                  : ""
                              }
                              readOnly
                              onWheel={(e) => { e.target.blur(); }}
                            />
                          </div>

                          <div className="form-group">
                            <label>Total Billing Price/Bag</label>
                            <input
                              type="number"
                              value={newPOForm.totalPrice}
                              onChange={(e) => handleNewPOChange("totalPrice", e.target.value)}
                              placeholder="Enter total price"
                              onWheel={(e) => { e.target.blur(); }}
                            />
                            {formErrors.totalPrice && <div className="error-message">{formErrors.totalPrice}</div>}
                          </div>

                          <div className="form-group">
                            <label>Packaging</label>
                            <input
                              type="text"
                              value={newPOForm.packaging}
                              onChange={(e) => handleNewPOChange("packaging", e.target.value)}
                              placeholder="Enter packaging"
                            />
                            {formErrors.packaging && <div className="error-message">{formErrors.packaging}</div>}
                          </div>
                          <div className="form-group">
                            <label>GST Number</label>
                            <input
                              type="text"
                              value={newPOForm.gstNo}
                              onChange={(e) => handleNewPOChange("gstNo", e.target.value)}
                              placeholder="Enter GST no"
                              onWheel={(e) => { e.target.blur(); }}
                            />
                            {formErrors.gstNo && <div className="error-message">{formErrors.gstNo}</div>}
                          </div>

                          <div className="form-group">
                            <label>PAN Number</label>
                            <input
                              type="text"
                              value={newPOForm.panNo}
                              onChange={(e) => handleNewPOChange("panNo", e.target.value)}
                              placeholder="Enter PAN no"
                              onWheel={(e) => { e.target.blur(); }}
                            />
                            {formErrors.panNo && <div className="error-message">{formErrors.panNo}</div>}
                          </div>

                          <div className="form-group">
                            <label>Payment Terms</label>
                            <input
                              type="text"
                              value={newPOForm.paymentTerms}
                              onChange={(e) => handleNewPOChange("paymentTerms", e.target.value)}
                              placeholder="Enter payment terms"
                            />
                            {formErrors.paymentTerms && <div className="error-message">{formErrors.paymentTerms}</div>}
                          </div>
                          <div className="form-group">
                            <label>Billing Address</label>
                            <input
                              type="text"
                              value={newPOForm.billingAddress}
                              onChange={(e) => handleNewPOChange("billingAddress", e.target.value)}
                              placeholder="Enter billing address"
                            />
                            {formErrors.billingAddress && <div className="error-message">{formErrors.billingAddress}</div>}
                          </div>
                          <div className="form-group">
                            <label>Contact Person</label>
                            <input
                              type="text"
                              value={newPOForm.contactPerson}
                              onChange={(e) => handleNewPOChange("contactPerson", e.target.value)}
                              placeholder="Enter contact person"
                            />
                            {formErrors.contactPerson && <div className="error-message">{formErrors.contactPerson}</div>}
                          </div>
                          <div className="form-group">
                            <label>Contact Mobile</label>
                            <input
                              type="text"
                              value={newPOForm.contactMobile}
                              onChange={(e) => handleNewPOChange("contactMobile", e.target.value)}
                              placeholder="Enter contact mobile"
                            />
                            {formErrors.contactMobile && <div className="error-message">{formErrors.contactMobile}</div>}
                          </div>
                          <div className="form-group">
                            <label>Delivery Schedule</label>
                            <input
                              type="text"
                              value={newPOForm.deliverySchedule}
                              onChange={(e) => handleNewPOChange("deliverySchedule", e.target.value)}
                              placeholder="Enter delivery schedule"
                              onWheel={(e) => { e.target.blur(); }}
                            />
                            {formErrors.deliverySchedule && <div className="error-message">{formErrors.deliverySchedule}</div>}
                          </div>
                          <div className="form-group">
                            <label>End Use of Cement</label>
                            <input
                              type="text"
                              value={newPOForm.endUse}
                              onChange={(e) => handleNewPOChange("endUse", e.target.value)}
                              placeholder="Enter end use"
                            />
                            {formErrors.endUse && <div className="error-message">{formErrors.endUse}</div>}
                          </div>
                          <div className="form-group">
                            <label>Category</label>
                            <input
                              type="text"
                              value={newPOForm.category}
                              onChange={(e) => handleNewPOChange("category", e.target.value)}
                              placeholder="Enter category"
                            />
                            {formErrors.category && <div className="error-message">{formErrors.category}</div>}
                          </div>
                          <div className="form-group">
                            <label>Email</label>
                            <input
                              type="email"
                              value={newPOForm.email}
                              onChange={(e) => handleNewPOChange("email", e.target.value)}
                              placeholder="Enter email"
                            />
                            {formErrors.email && <div className="error-message">{formErrors.email}</div>}
                          </div>
                          <div className="form-group">
                            <label>TPC Code</label>
                            <input
                              type="text"
                              value={newPOForm.tpcCode}
                              onChange={(e) => handleNewPOChange("tpcCode", e.target.value)}
                              placeholder="Enter TPC code"
                            />
                            {formErrors.tpcCode && <div className="error-message">{formErrors.tpcCode}</div>}
                          </div>
                          <div className="form-group">
                            <label>Brand</label>
                            <select
                              value={newPOForm.brand}
                              onChange={(e) => handleNewPOChange("brand", e.target.value)}
                            >
                              <option value="">--Select Brand--</option>
                              <option value="Ultratech">Ultratech</option>
                              <option value="Shree">Shree</option>
                              <option value="JSW">JSW</option>
                              <option value="JKSuper">JKSuper</option>
                              <option value="ACC">ACC</option>
                              <option value="Ambuja">Ambuja</option>
                            </select>
                          </div>
                          <div className="form-group">
                            <label>Company Name</label>
                            <input
                              type="text"
                              value={newPOForm.companyName}
                              onChange={(e) => handleNewPOChange("companyName", e.target.value)}
                              placeholder="Enter company name"
                            />
                            {formErrors.companyName && <div className="error-message">{formErrors.companyName}</div>}
                          </div>
                          <div className="form-group">
                            <label>Quantity Type(Bags/MT)</label>
                            <input
                              type="text"
                              value={newPOForm.quantityType}
                              onChange={(e) => handleNewPOChange("quantityType", e.target.value)}
                              placeholder="Enter quantity type"
                            />
                            {formErrors.quantityType && <div className="error-message">{formErrors.quantityType}</div>}
                          </div>
                          <div className="form-actions">
                            <button className="submit-button" onClick={handleSubmitNewPO} disabled={loading}>
                              {loading ? (
                                <>
                                  <FaSpinner className="spinner-icon" /> Submitting...
                                </>
                              ) : (
                                <>
                                  <FaSave className="button-icon" /> Add New PO
                                </>
                              )}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </>
          ) : (
            <div className="no-user-selected">
              <div className="no-user-content">
                <FaUser className="no-user-icon" />
                <h2>No User Selected</h2>
                <p>Please select a user from the list to view their profile and manage documents.</p>
              </div>
            </div>
          )}
        </div>
      </div>

      {error && (
        <div className="error-message">
          <p>{error}</p>
          <button onClick={() => setError("")} className="close-error">
            ×
          </button>
        </div>
      )}
    </div>
  )
}

export default UserDocumentManagement